// This file is auto-generated by @hey-api/openapi-ts

export const $RolePermissionsType = {
    properties: {
        ACCOUNT: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        TRANSACTION: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        BANK_ACCOUNT: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        BANK_ACCOUNT_TRANSACTION: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        EXPENSE_CATEGORY: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        EXPENSE: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        TAXES: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        CURRENCY: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        CUSTOMER: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        INVOICE: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        VENDOR: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        PRODUCTS: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        PURCHASE_ORDER: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        PRODUCT_CATEGORY: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        BRAND: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        LOCATION: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        SETTINGS: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        USER: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        SERVICE_CATEGORY: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        SERVICE: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        REPORTS: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        INVENTORY_TRANSACTION: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        INVENTORY_STOCK: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        },
        REPARATIONS: {
            properties: {
                PRINT: {
                    type: 'boolean'
                },
                DOWNLOAD: {
                    type: 'boolean'
                },
                DELETE: {
                    type: 'boolean'
                },
                UPDATE: {
                    type: 'boolean'
                },
                CREATE: {
                    type: 'boolean'
                },
                READ: {
                    type: 'boolean'
                }
            },
            required: ['PRINT', 'DOWNLOAD', 'DELETE', 'UPDATE', 'CREATE', 'READ'],
            type: 'object'
        }
    },
    required: ['ACCOUNT', 'TRANSACTION', 'BANK_ACCOUNT', 'BANK_ACCOUNT_TRANSACTION', 'EXPENSE_CATEGORY', 'EXPENSE', 'TAXES', 'CURRENCY', 'CUSTOMER', 'INVOICE', 'VENDOR', 'PRODUCTS', 'PURCHASE_ORDER', 'PRODUCT_CATEGORY', 'BRAND', 'LOCATION', 'SETTINGS', 'USER', 'SERVICE_CATEGORY', 'SERVICE', 'REPORTS', 'INVENTORY_TRANSACTION', 'INVENTORY_STOCK', 'REPARATIONS'],
    type: 'object'
} as const;

export const $LoginResponse = {
    properties: {
        token: {
            type: 'string'
        },
        user: {
            properties: {
                isActive: {
                    type: 'boolean'
                },
                userAddress: {
                    type: 'string'
                },
                userPhone: {
                    type: 'string'
                },
                userEmail: {
                    type: 'string'
                },
                userFullName: {
                    type: 'string'
                },
                userName: {
                    type: 'string'
                },
                updatedDate: {
                    type: 'string',
                    format: 'date-time'
                },
                updatedBy: {
                    type: 'string'
                },
                createdDate: {
                    type: 'string',
                    format: 'date-time'
                },
                createdBy: {
                    type: 'string'
                }
            },
            required: ['isActive', 'userAddress', 'userPhone', 'userEmail', 'userFullName', 'userName', 'createdDate', 'createdBy'],
            type: 'object'
        },
        role: {
            properties: {
                rolePermissions: {
                    '$ref': '#/components/schemas/RolePermissionsType'
                },
                roleDescription: {
                    type: 'string'
                },
                roleName: {
                    type: 'string'
                }
            },
            required: ['rolePermissions', 'roleDescription', 'roleName'],
            type: 'object'
        },
        company: {
            properties: {
                isActive: {
                    type: 'boolean'
                },
                companyLogo: {
                    type: 'string'
                },
                companyDescription: {
                    type: 'string'
                },
                companyName: {
                    type: 'string'
                }
            },
            required: ['isActive', 'companyLogo', 'companyDescription', 'companyName'],
            type: 'object'
        }
    },
    required: ['token', 'user', 'role', 'company'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IRole = {
    properties: {
        idRole: {
            type: 'number',
            format: 'double'
        },
        roleName: {
            type: 'string'
        },
        roleDescription: {
            type: 'string'
        },
        rolePermissions: {
            items: {
                '$ref': '#/components/schemas/RolePermissionsType'
            },
            type: 'array'
        },
        isActive: {
            type: 'boolean'
        },
        createdDate: {
            type: 'string',
            format: 'date-time'
        },
        updatedDate: {
            type: 'string',
            format: 'date-time'
        },
        createdBy: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {}
            ]
        },
        updatedBy: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {}
            ]
        }
    },
    required: ['idRole', 'roleName', 'roleDescription', 'rolePermissions', 'isActive', 'createdDate', 'updatedDate', 'createdBy', 'updatedBy'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IAccountItem = {
    properties: {
        idAccount: {
            type: 'number',
            format: 'double'
        },
        accountName: {
            type: 'string'
        },
        accountNumber: {
            type: 'string'
        },
        accountDescription: {
            type: 'string'
        },
        accountType: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        refIdCurrency: {},
        company: {
            type: 'number',
            format: 'double'
        },
        parentAccount: {
            '$ref': '#/components/schemas/IAccountItem'
        },
        childAccounts: {
            items: {
                '$ref': '#/components/schemas/IAccountItem'
            },
            type: 'array'
        },
        accountSubtype: {
            type: 'string'
        },
        accountGroup: {
            type: 'string'
        },
        accountSubGroup: {
            type: 'string'
        },
        calculatedBalance: {
            type: 'number',
            format: 'double'
        },
        currency: {
            '$ref': '#/components/schemas/ICurrency'
        }
    },
    required: ['idAccount', 'accountName', 'accountNumber', 'accountType', 'isActive', 'refIdCurrency', 'company', 'parentAccount', 'childAccounts', 'accountSubtype', 'accountGroup', 'accountSubGroup'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICurrency = {
    properties: {
        idCurrency: {
            type: 'number',
            format: 'double'
        },
        currencyName: {
            type: 'string'
        },
        currencyCode: {
            type: 'string'
        },
        currencySymbol: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        isDefault: {
            type: 'boolean'
        },
        company: {},
        exchangeRate: {
            '$ref': '#/components/schemas/IExchangeRate'
        },
        createdDate: {
            type: 'string',
            format: 'date-time'
        }
    },
    required: ['idCurrency', 'currencyName', 'currencyCode', 'currencySymbol', 'isActive', 'isDefault', 'company', 'createdDate'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IExchangeRate = {
    properties: {
        idExchangeRate: {
            type: 'number',
            format: 'double'
        },
        currency: {
            '$ref': '#/components/schemas/ICurrency'
        },
        rate: {
            type: 'number',
            format: 'double'
        },
        date: {
            type: 'string',
            format: 'date-time'
        },
        isActive: {
            type: 'boolean'
        },
        createdDate: {
            type: 'string',
            format: 'date-time'
        },
        createdBy: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {}
            ]
        },
        updatedDate: {
            type: 'string',
            format: 'date-time'
        },
        updatedBy: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {}
            ]
        }
    },
    required: ['idExchangeRate', 'currency', 'rate', 'date', 'isActive', 'createdDate', 'createdBy'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUser = {
    properties: {
        idUser: {
            type: 'number',
            format: 'double'
        },
        userName: {
            type: 'string'
        },
        userFullName: {
            type: 'string'
        },
        userEmail: {
            type: 'string'
        },
        userPhone: {
            type: 'string'
        },
        userAddress: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        createdDate: {
            type: 'string',
            format: 'date-time'
        },
        updatedDate: {
            type: 'string',
            format: 'date-time'
        },
        createdBy: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {}
            ]
        },
        updatedBy: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {}
            ]
        },
        company: {
            type: 'number',
            format: 'double'
        },
        role: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {
                    '$ref': '#/components/schemas/IRole'
                }
            ]
        },
        account: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {
                    '$ref': '#/components/schemas/IAccountItem'
                }
            ]
        },
        salary: {
            type: 'number',
            format: 'double'
        },
        location: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {
                    properties: {
                        locationName: {
                            type: 'string'
                        },
                        idLocation: {
                            type: 'number',
                            format: 'double'
                        }
                    },
                    required: ['locationName', 'idLocation'],
                    type: 'object'
                }
            ]
        }
    },
    required: ['idUser', 'userName', 'userFullName', 'userEmail', 'userPhone', 'userAddress', 'isActive', 'createdDate', 'updatedDate', 'createdBy', 'updatedBy', 'company', 'role'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetUsersResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IUser'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICommonQueryInput = {
    properties: {
        filters: {
            type: 'string'
        },
        sort: {
            type: 'string'
        },
        pagination: {
            type: 'string'
        },
        searchQuery: {
            type: 'string'
        }
    },
    required: ['filters', 'sort', 'pagination'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreateUserInput = {
    properties: {
        userName: {
            type: 'string'
        },
        userFullName: {
            type: 'string'
        },
        userEmail: {
            type: 'string'
        },
        userPassword: {
            type: 'string'
        },
        userPhone: {
            type: 'string'
        },
        userAddress: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        userRole: {
            type: 'number',
            format: 'double'
        },
        accountId: {
            type: 'number',
            format: 'double'
        },
        salary: {
            type: 'number',
            format: 'double'
        },
        locationId: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['userName', 'userFullName', 'userEmail', 'userPassword', 'userPhone', 'userAddress', 'userRole'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdateUserInput = {
    properties: {
        userName: {
            type: 'string'
        },
        userFullName: {
            type: 'string'
        },
        userEmail: {
            type: 'string'
        },
        userPassword: {
            type: 'string'
        },
        userPhone: {
            type: 'string'
        },
        userAddress: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        userRole: {
            type: 'number',
            format: 'double'
        },
        accountId: {
            type: 'number',
            format: 'double'
        },
        salary: {
            type: 'number',
            format: 'double'
        },
        locationId: {
            type: 'number',
            format: 'double'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetUserResponse = {
    properties: {
        idUser: {
            type: 'number',
            format: 'double'
        },
        userName: {
            type: 'string'
        },
        userFullName: {
            type: 'string'
        },
        userEmail: {
            type: 'string'
        },
        userPhone: {
            type: 'string'
        },
        userAddress: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        createdDate: {
            type: 'string',
            format: 'date-time'
        },
        updatedDate: {
            type: 'string',
            format: 'date-time'
        },
        createdBy: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {}
            ]
        },
        updatedBy: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {}
            ]
        },
        company: {
            type: 'number',
            format: 'double'
        },
        role: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {
                    '$ref': '#/components/schemas/IRole'
                }
            ]
        },
        account: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {
                    '$ref': '#/components/schemas/IAccountItem'
                }
            ]
        },
        salary: {
            type: 'number',
            format: 'double'
        },
        location: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {
                    properties: {
                        locationName: {
                            type: 'string'
                        },
                        idLocation: {
                            type: 'number',
                            format: 'double'
                        }
                    },
                    required: ['locationName', 'idLocation'],
                    type: 'object'
                }
            ]
        }
    },
    required: ['idUser', 'userName', 'userFullName', 'userEmail', 'userPhone', 'userAddress', 'isActive', 'createdDate', 'updatedDate', 'createdBy', 'updatedBy', 'company', 'role'],
    type: 'object',
    additionalProperties: false
} as const;

export const $GetRolesResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IRole'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $GetRoleResponse = {
    properties: {
        idRole: {
            type: 'number',
            format: 'double'
        },
        roleName: {
            type: 'string'
        },
        roleDescription: {
            type: 'string'
        },
        rolePermissions: {
            items: {
                '$ref': '#/components/schemas/RolePermissionsType'
            },
            type: 'array'
        },
        isActive: {
            type: 'boolean'
        },
        createdDate: {
            type: 'string',
            format: 'date-time'
        },
        updatedDate: {
            type: 'string',
            format: 'date-time'
        },
        createdBy: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {}
            ]
        },
        updatedBy: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {}
            ]
        }
    },
    required: ['idRole', 'roleName', 'roleDescription', 'rolePermissions', 'isActive', 'createdDate', 'updatedDate', 'createdBy', 'updatedBy'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreateRoleInput = {
    properties: {
        roleName: {
            type: 'string'
        },
        roleDescription: {
            type: 'string'
        },
        rolePermissions: {
            '$ref': '#/components/schemas/RolePermissionsType'
        }
    },
    required: ['roleName', 'roleDescription'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdateRoleInput = {
    properties: {
        roleName: {
            type: 'string'
        },
        roleDescription: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        rolePermissions: {
            '$ref': '#/components/schemas/RolePermissionsType'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $IProductVariantTypeItem = {
    properties: {
        idProductVariantType: {
            type: 'number',
            format: 'double'
        },
        name: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        productVariantValues: {
            items: {
                '$ref': '#/components/schemas/IProductVariantValueItem'
            },
            type: 'array'
        }
    },
    required: ['idProductVariantType', 'name'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IProductVariantValueItem = {
    properties: {
        idProductVariant: {
            type: 'number',
            format: 'double'
        },
        name: {
            type: 'string'
        },
        productVariantType: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {
                    '$ref': '#/components/schemas/IProductVariantTypeItem'
                }
            ]
        }
    },
    required: ['idProductVariant', 'name'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetProductVariantTypesResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IProductVariantTypeItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreateProductVariantTypeInput = {
    properties: {
        name: {
            type: 'string'
        },
        variantTypeValues: {
            items: {
                properties: {
                    name: {
                        type: 'string'
                    }
                },
                required: ['name'],
                type: 'object'
            },
            type: 'array'
        }
    },
    required: ['name', 'variantTypeValues'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetProductVariantValuesResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IProductVariantValueItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreateProductVariantValueInput = {
    properties: {
        name: {
            type: 'string'
        },
        productVariantType: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['name', 'productVariantType'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICompanyDetailsResponse = {
    properties: {
        idCompany: {
            type: 'number',
            format: 'double'
        },
        companyName: {
            type: 'string'
        },
        companyAddress: {
            type: 'string'
        },
        companyPhone: {
            type: 'string'
        },
        companyEmail: {
            type: 'string'
        },
        companyWebsite: {
            type: 'string'
        },
        baseCurrency: {
            type: 'string'
        },
        currencySymbol: {
            type: 'string'
        },
        currencyCode: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        }
    },
    required: ['idCompany', 'companyName', 'companyAddress', 'companyPhone', 'companyEmail', 'companyWebsite', 'baseCurrency', 'currencySymbol', 'currencyCode', 'isActive'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICompanyDetailsInput = {
    properties: {
        companyName: {
            type: 'string'
        },
        companyAddress: {
            type: 'string'
        },
        companyPhone: {
            type: 'string'
        },
        companyEmail: {
            type: 'string'
        },
        companyWebsite: {
            type: 'string'
        },
        baseCurrency: {
            type: 'string'
        },
        currencySymbol: {
            type: 'string'
        },
        currencyCode: {
            type: 'string'
        }
    },
    required: ['companyName', 'companyAddress', 'companyPhone', 'companyEmail', 'companyWebsite', 'baseCurrency', 'currencySymbol', 'currencyCode'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IPaymentMethodItem = {
    properties: {
        idPaymentMethod: {
            type: 'number',
            format: 'double'
        },
        paymentMethodName: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        account: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {
                    properties: {
                        idAccount: {
                            type: 'number',
                            format: 'double'
                        }
                    },
                    additionalProperties: {},
                    required: ['idAccount'],
                    type: 'object'
                }
            ]
        }
    },
    required: ['idPaymentMethod', 'paymentMethodName', 'isActive'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IListPaymentMethodsResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IPaymentMethodItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreatePaymentMethodInput = {
    properties: {
        paymentMethodName: {
            type: 'string'
        },
        account: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['paymentMethodName'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdatePaymentMethodInput = {
    properties: {
        paymentMethodName: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        account: {
            type: 'number',
            format: 'double'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $IVendor = {
    properties: {
        idVendor: {
            type: 'number',
            format: 'double'
        },
        vendorName: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        country: {
            type: 'string'
        },
        city: {
            type: 'string'
        },
        address: {
            type: 'string'
        },
        phone: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        website: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        createdBy: {
            type: 'string'
        },
        createdDate: {
            type: 'string',
            format: 'date-time'
        },
        updatedBy: {
            type: 'string'
        },
        updatedDate: {
            type: 'string',
            format: 'date-time'
        }
    },
    required: ['idVendor', 'vendorName'],
    type: 'object',
    additionalProperties: false
} as const;

export const $VendorListResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IVendor'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $CreateVendorInput = {
    properties: {
        vendorName: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        phone: {
            type: 'string'
        },
        address: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        country: {
            type: 'string'
        },
        website: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        wechatId: {
            type: 'string'
        },
        altPhone: {
            type: 'string'
        },
        whatsappPhone: {
            type: 'string'
        }
    },
    required: ['vendorName'],
    type: 'object',
    additionalProperties: false
} as const;

export const $PurchaseOrderStatus = {
    enum: ['DRAFT', 'SENT', 'APPROVED', 'ON_ROUTE', 'PARTIALLY_RECEIVED', 'PARTIALLY_PAID', 'FULLY_RECEIVED', 'FULLY_PAID', 'CANCELLED'],
    type: 'string'
} as const;

export const $TaxType = {
    enum: ['PERCENTAGE', 'FIXED'],
    type: 'string'
} as const;

export const $ITaxItem = {
    properties: {
        idTax: {
            type: 'number',
            format: 'double'
        },
        taxName: {
            type: 'string'
        },
        taxRate: {
            type: 'number',
            format: 'double'
        },
        taxType: {
            '$ref': '#/components/schemas/TaxType'
        },
        taxDescription: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        }
    },
    required: ['idTax', 'taxName', 'taxRate', 'taxType', 'taxDescription', 'isActive'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IProductItem = {
    properties: {
        idProduct: {
            type: 'number',
            format: 'double'
        },
        productName: {
            type: 'string'
        },
        productDescription: {
            type: 'string'
        },
        productImage: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        productSku: {
            type: 'string'
        },
        productBarcode: {
            type: 'string'
        },
        productEan: {
            type: 'string'
        },
        productUpc: {
            type: 'string'
        },
        productGtin: {
            type: 'string'
        },
        productWeight: {
            type: 'string'
        },
        productWeightUnit: {
            type: 'string'
        },
        productDimensionUnit: {
            type: 'string'
        },
        productLength: {
            type: 'string'
        },
        productWidth: {
            type: 'string'
        },
        productHeight: {
            type: 'string'
        },
        productDimension: {
            type: 'string'
        },
        productPrice: {
            type: 'string'
        },
        productCost: {
            type: 'string'
        },
        productCurrency: {
            type: 'string'
        },
        productStock: {
            type: 'string'
        },
        productStockUnit: {
            type: 'string'
        },
        warrantyInfo: {
            type: 'string'
        },
        regulatoryCompliance: {
            type: 'string'
        },
        productIdCode: {
            type: 'string'
        }
    },
    required: ['idProduct', 'productName', 'isActive'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IPurchaseOrderItem = {
    properties: {
        idPurchaseOrderItem: {
            type: 'number',
            format: 'double'
        },
        product: {
            '$ref': '#/components/schemas/IProductItem'
        },
        quantity: {
            type: 'number',
            format: 'double'
        },
        unitPrice: {
            type: 'number',
            format: 'double'
        },
        totalPrice: {
            type: 'number',
            format: 'double'
        },
        exchangeRateAmount: {
            type: 'number',
            format: 'double'
        },
        discountScheme: {
            type: 'string'
        },
        discountAmount: {
            type: 'number',
            format: 'double'
        },
        taxAmount: {
            type: 'number',
            format: 'double'
        },
        tax: {
            '$ref': '#/components/schemas/ITaxItem'
        },
        currency: {
            '$ref': '#/components/schemas/ICurrency'
        },
        exchangeRate: {
            '$ref': '#/components/schemas/IExchangeRate'
        },
        createdDate: {
            type: 'string',
            format: 'date-time'
        },
        createdBy: {},
        updatedDate: {
            type: 'string',
            format: 'date-time'
        },
        updatedBy: {}
    },
    required: ['idPurchaseOrderItem', 'product', 'quantity', 'unitPrice', 'totalPrice', 'exchangeRateAmount', 'createdDate', 'createdBy'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ILocationItem = {
    properties: {
        idLocation: {
            type: 'number',
            format: 'double'
        },
        locationName: {
            type: 'string'
        },
        locationDescription: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        locationType: {
            type: 'string'
        },
        createdBy: {
            type: 'string'
        },
        createdDate: {
            type: 'string',
            format: 'date-time'
        },
        modifiedBy: {
            type: 'string'
        },
        modifiedDate: {
            type: 'string',
            format: 'date-time'
        }
    },
    required: ['idLocation', 'locationName', 'locationDescription', 'isActive', 'locationType', 'createdBy', 'createdDate', 'modifiedBy', 'modifiedDate'],
    type: 'object',
    additionalProperties: false
} as const;

export const $PurchaseOrderDeliveryStatus = {
    enum: ['PENDING', 'ON_ROUTE', 'DELIVERED', 'CANCELLED', 'PROCESSING'],
    type: 'string'
} as const;

export const $IPurchaseOrderHistoryItem = {
    properties: {
        idPurchaseOrderHistory: {
            type: 'number',
            format: 'double'
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        status: {
            type: 'string'
        },
        action: {
            type: 'string'
        },
        entryDate: {
            type: 'string',
            format: 'date-time'
        }
    },
    required: ['idPurchaseOrderHistory', 'title', 'entryDate'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IDeliverNote = {
    properties: {
        idDeliveryNote: {
            type: 'number',
            format: 'double'
        },
        deliverNoteDescription: {
            type: 'string'
        },
        deliveryNoteNumber: {
            type: 'string'
        },
        entryDate: {
            type: 'string',
            format: 'date-time'
        },
        deliveryNoteItems: {
            items: {
                '$ref': '#/components/schemas/IDeliverNoteItem'
            },
            type: 'array'
        }
    },
    required: ['idDeliveryNote', 'deliverNoteDescription', 'deliveryNoteNumber', 'entryDate', 'deliveryNoteItems'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IInventoryTransactionItem = {
    properties: {
        idInventoryTransaction: {
            type: 'number',
            format: 'double'
        },
        transactionDate: {
            type: 'string',
            format: 'date-time'
        },
        transactionType: {
            type: 'string'
        },
        quantity: {
            type: 'number',
            format: 'double'
        },
        product: {
            '$ref': '#/components/schemas/IProductItem'
        },
        locationFrom: {
            '$ref': '#/components/schemas/ILocationItem'
        },
        locationTo: {
            '$ref': '#/components/schemas/ILocationItem'
        },
        inventoryTransactionDescription: {
            type: 'string'
        }
    },
    required: ['idInventoryTransaction', 'transactionDate', 'transactionType', 'quantity', 'product'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IDeliverNoteItem = {
    properties: {
        idDeliveryNoteItem: {
            type: 'number',
            format: 'double'
        },
        quantity: {
            type: 'number',
            format: 'double'
        },
        deliveryNote: {
            '$ref': '#/components/schemas/IDeliverNote'
        },
        product: {
            '$ref': '#/components/schemas/IProductItem'
        },
        location: {
            '$ref': '#/components/schemas/ILocationItem'
        },
        inventoryTransaction: {
            '$ref': '#/components/schemas/IInventoryTransactionItem'
        }
    },
    required: ['idDeliveryNoteItem', 'quantity', 'deliveryNote', 'product', 'location', 'inventoryTransaction'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IPurchaseOrder = {
    properties: {
        idPurchaseOrder: {
            type: 'number',
            format: 'double'
        },
        purchaseOrderNumber: {
            type: 'string'
        },
        purchaseOrderDate: {
            type: 'string',
            format: 'date-time'
        },
        purchaseOrderDeliveryDate: {
            type: 'string',
            format: 'date-time'
        },
        purchaseOrderNotes: {
            type: 'string'
        },
        status: {
            '$ref': '#/components/schemas/PurchaseOrderStatus'
        },
        isActive: {
            type: 'boolean'
        },
        vendor: {
            '$ref': '#/components/schemas/IVendor'
        },
        exchangeRateAmount: {
            type: 'number',
            format: 'double'
        },
        discountScheme: {
            type: 'string'
        },
        discountAmount: {
            type: 'number',
            format: 'double'
        },
        shippingChargeTax: {
            type: 'number',
            format: 'double'
        },
        currency: {
            '$ref': '#/components/schemas/ICurrency'
        },
        shippingType: {
            type: 'string'
        },
        tax: {
            '$ref': '#/components/schemas/ITaxItem'
        },
        subtotal: {
            type: 'number',
            format: 'double'
        },
        shippingCharge: {
            type: 'number',
            format: 'double'
        },
        discountTotal: {
            type: 'number',
            format: 'double'
        },
        taxTotal: {
            type: 'number',
            format: 'double'
        },
        totalAmount: {
            type: 'number',
            format: 'double'
        },
        purchaseOrderItems: {
            items: {
                '$ref': '#/components/schemas/IPurchaseOrderItem'
            },
            type: 'array'
        },
        location: {
            '$ref': '#/components/schemas/ILocationItem'
        },
        deliveryStatus: {
            '$ref': '#/components/schemas/PurchaseOrderDeliveryStatus'
        },
        subject: {
            type: 'string'
        },
        purchaseOrderHistory: {
            items: {
                '$ref': '#/components/schemas/IPurchaseOrderHistoryItem'
            },
            type: 'array'
        },
        totalPaymentsAmount: {
            type: 'number',
            format: 'double'
        },
        deliveryNote: {
            '$ref': '#/components/schemas/IDeliverNote'
        },
        paymentMethod: {
            '$ref': '#/components/schemas/IPaymentMethodItem'
        }
    },
    required: ['idPurchaseOrder', 'purchaseOrderNumber', 'purchaseOrderDate', 'purchaseOrderDeliveryDate', 'purchaseOrderNotes', 'status', 'isActive', 'vendor', 'exchangeRateAmount', 'subtotal', 'taxTotal', 'totalAmount'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetPurchaseOrderResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IPurchaseOrder'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IVendorStatementOfAccountItem = {
    properties: {
        key: {
            type: 'string'
        },
        date: {
            type: 'string',
            format: 'date-time'
        },
        description: {
            type: 'string'
        },
        amount: {
            type: 'number',
            format: 'double'
        },
        balance: {
            type: 'number',
            format: 'double'
        },
        type: {
            type: 'string',
            enum: ['PURCHASE', 'PAYMENT']
        }
    },
    required: ['key', 'date', 'description', 'amount', 'balance', 'type'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdateVendorInput = {
    properties: {
        vendorName: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        country: {
            type: 'string'
        },
        address: {
            type: 'string'
        },
        phone: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        website: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        wechatId: {
            type: 'string'
        },
        altPhone: {
            type: 'string'
        },
        whatsappPhone: {
            type: 'string'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $ServiceCategoryItem = {
    properties: {
        idServiceCategory: {
            type: 'number',
            format: 'double'
        },
        serviceCategoryName: {
            type: 'string'
        },
        serviceCategoryDescription: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        }
    },
    required: ['idServiceCategory', 'serviceCategoryName', 'serviceCategoryDescription', 'isActive'],
    type: 'object',
    additionalProperties: false
} as const;

export const $GetServiceCategoryResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/ServiceCategoryItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $GetServiceCategoryInput = {
    properties: {
        filters: {
            type: 'string'
        },
        pagination: {
            type: 'string'
        },
        sort: {
            type: 'string'
        }
    },
    required: ['filters', 'pagination', 'sort'],
    type: 'object',
    additionalProperties: false
} as const;

export const $CreateServiceCategoryInput = {
    properties: {
        serviceCategoryName: {
            type: 'string'
        },
        serviceCategoryDescription: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        }
    },
    required: ['serviceCategoryName'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ServiceItem = {
    properties: {
        idService: {
            type: 'number',
            format: 'double'
        },
        serviceName: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        unitPrice: {
            type: 'number',
            format: 'double'
        },
        defaultAccount: {},
        serviceCategory: {},
        isActive: {
            type: 'boolean'
        }
    },
    required: ['idService', 'serviceName', 'description', 'isActive'],
    type: 'object',
    additionalProperties: false
} as const;

export const $GetServicesResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/ServiceItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $GetLocationResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/ILocationItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $LocationType = {
    enum: ['WAREHOUSE', 'STORE', 'OFFICE', 'FACTORY', 'OTHER'],
    type: 'string'
} as const;

export const $IUpdateLocationInput = {
    properties: {
        locationName: {
            type: 'string'
        },
        locationType: {
            '$ref': '#/components/schemas/LocationType'
        },
        locationDescription: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $IBrandItem = {
    properties: {
        idBrand: {
            type: 'number',
            format: 'double'
        },
        brandName: {
            type: 'string'
        },
        brandDescription: {
            type: 'string'
        },
        brandImage: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        }
    },
    required: ['idBrand', 'brandName', 'isActive'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetBrandsResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IBrandItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreateBrandInput = {
    properties: {
        brandName: {
            type: 'string'
        },
        brandDescription: {
            type: 'string'
        },
        brandLogo: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        }
    },
    required: ['brandName'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdateBrandInput = {
    properties: {
        brandName: {
            type: 'string'
        },
        brandDescription: {
            type: 'string'
        },
        brandLogo: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $IProductCategoryItem = {
    properties: {
        idProductCategory: {
            type: 'number',
            format: 'double'
        },
        productCategoryName: {
            type: 'string'
        },
        productCategoryDescription: {
            type: 'string'
        },
        productCategoryImage: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        children: {
            items: {
                '$ref': '#/components/schemas/IProductCategoryItem'
            },
            type: 'array'
        }
    },
    required: ['idProductCategory', 'productCategoryName', 'isActive', 'children'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetProductCategoryResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IProductCategoryItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetProductCategoryOptionItemsResponse = {
    properties: {
        idProductCategory: {
            type: 'number',
            format: 'double'
        },
        productCategoryName: {
            type: 'string'
        },
        productCategoryDescription: {
            type: 'string'
        },
        productCategoryImage: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        children: {
            items: {
                '$ref': '#/components/schemas/IProductCategoryItem'
            },
            type: 'array'
        }
    },
    required: ['idProductCategory', 'productCategoryName', 'isActive', 'children'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdateProductCategoryInput = {
    properties: {
        productCategoryName: {
            type: 'string'
        },
        productCategoryDescription: {
            type: 'string'
        },
        parentCategory: {
            type: 'number',
            format: 'double'
        },
        isActive: {
            type: 'boolean'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetProductResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IProductItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        totalVariants: {
            type: 'number',
            format: 'double'
        },
        totalProducts: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $CreateProductInput = {
    properties: {
        productName: {
            type: 'string'
        },
        productDescription: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        company: {
            type: 'number',
            format: 'double'
        },
        productCategory: {
            type: 'number',
            format: 'double'
        },
        brand: {
            type: 'number',
            format: 'double'
        },
        productSku: {
            type: 'string'
        },
        productBarcode: {
            type: 'string'
        },
        productEan: {
            type: 'string'
        },
        productUpc: {
            type: 'string'
        },
        productGtin: {
            type: 'string'
        },
        productWeight: {
            type: 'number',
            format: 'double'
        },
        productWeightUnit: {
            type: 'string'
        },
        productDimensionUnit: {
            type: 'string'
        },
        productLength: {
            type: 'number',
            format: 'double'
        },
        productWidth: {
            type: 'number',
            format: 'double'
        },
        productHeight: {
            type: 'number',
            format: 'double'
        },
        productDimension: {
            type: 'number',
            format: 'double'
        },
        productImage: {
            type: 'string'
        },
        productVideo: {
            type: 'string'
        },
        productPrice: {
            type: 'number',
            format: 'double'
        },
        productCost: {
            type: 'number',
            format: 'double'
        },
        productLowStockAlert: {
            type: 'number',
            format: 'double'
        },
        productIdealStock: {
            type: 'number',
            format: 'double'
        },
        productModelNumber: {
            type: 'string'
        },
        modelCompatibility: {
            items: {
                type: 'number',
                format: 'double'
            },
            type: 'array'
        },
        warrantyInfo: {
            type: 'string'
        },
        regulatoryCompliance: {
            type: 'string'
        },
        productIdCode: {
            type: 'string'
        },
        productGrade: {
            type: 'string'
        },
        touchScreenCapability: {
            type: 'string'
        },
        productSubcategory: {
            type: 'number',
            format: 'double'
        },
        variantIds: {
            items: {
                type: 'number',
                format: 'double'
            },
            type: 'array'
        },
        locationId: {
            type: 'number',
            format: 'double'
        },
        initialQuantity: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['productName', 'company', 'productCategory', 'brand', 'productBarcode'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdateProductInput = {
    properties: {
        productName: {
            type: 'string'
        },
        productDescription: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        company: {
            type: 'number',
            format: 'double'
        },
        productCategory: {
            type: 'number',
            format: 'double'
        },
        brand: {
            type: 'number',
            format: 'double'
        },
        productSku: {
            type: 'string'
        },
        productBarcode: {
            type: 'string'
        },
        productEan: {
            type: 'string'
        },
        productUpc: {
            type: 'string'
        },
        productModelNumber: {
            type: 'string'
        },
        productGtin: {
            type: 'string'
        },
        productWeight: {
            type: 'number',
            format: 'double'
        },
        productWeightUnit: {
            type: 'string'
        },
        productDimensionUnit: {
            type: 'string'
        },
        productLength: {
            type: 'number',
            format: 'double'
        },
        productWidth: {
            type: 'number',
            format: 'double'
        },
        productHeight: {
            type: 'number',
            format: 'double'
        },
        productDimension: {
            type: 'number',
            format: 'double'
        },
        productImage: {
            type: 'string'
        },
        productVideo: {
            type: 'string'
        },
        productPrice: {
            type: 'number',
            format: 'double'
        },
        productCost: {
            type: 'number',
            format: 'double'
        },
        productLowStockAlert: {
            type: 'number',
            format: 'double'
        },
        productIdealStock: {
            type: 'number',
            format: 'double'
        },
        modelCompatibility: {
            items: {
                type: 'number',
                format: 'double'
            },
            type: 'array'
        },
        warrantyInfo: {
            type: 'string'
        },
        regulatoryCompliance: {
            type: 'string'
        },
        productIdCode: {
            type: 'string'
        },
        productGrade: {
            type: 'string'
        },
        touchScreenCapability: {
            type: 'string'
        },
        productSubcategory: {
            type: 'number',
            format: 'double'
        },
        variantIds: {
            items: {
                type: 'number',
                format: 'double'
            },
            type: 'array'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $IProductDetails = {
    properties: {
        idProduct: {
            type: 'number',
            format: 'double'
        },
        productName: {
            type: 'string'
        },
        productDescription: {
            type: 'string'
        },
        productImage: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        productSku: {
            type: 'string'
        },
        productBarcode: {
            type: 'string'
        },
        productEan: {
            type: 'string'
        },
        productUpc: {
            type: 'string'
        },
        productGtin: {
            type: 'string'
        },
        productWeight: {
            type: 'string'
        },
        productWeightUnit: {
            type: 'string'
        },
        productDimensionUnit: {
            type: 'string'
        },
        productLength: {
            type: 'string'
        },
        productWidth: {
            type: 'string'
        },
        productHeight: {
            type: 'string'
        },
        productDimension: {
            type: 'string'
        },
        productPrice: {
            type: 'string'
        },
        productCost: {
            type: 'string'
        },
        productCurrency: {
            type: 'string'
        },
        productStock: {
            type: 'string'
        },
        productStockUnit: {
            type: 'string'
        },
        brand: {
            '$ref': '#/components/schemas/IBrandItem'
        },
        productCategory: {
            '$ref': '#/components/schemas/IProductCategoryItem'
        },
        productLowStockAlert: {
            type: 'number',
            format: 'double'
        },
        productIdealStock: {
            type: 'number',
            format: 'double'
        },
        tax: {
            type: 'number',
            enum: [
                null
            ],
            nullable: true
        },
        costCurrency: {
            type: 'number',
            enum: [
                null
            ],
            nullable: true
        },
        variants: {
            items: {
                '$ref': '#/components/schemas/IProductDetails'
            },
            type: 'array'
        },
        warrantyInfo: {
            type: 'string'
        },
        regulatoryCompliance: {
            type: 'string'
        },
        productIdCode: {
            type: 'string'
        },
        productGrade: {
            type: 'string'
        },
        touchScreenCapability: {
            type: 'string'
        },
        productSubcategory: {
            '$ref': '#/components/schemas/IProductCategoryItem'
        },
        itemsPerLocation: {
            items: {
                '$ref': '#/components/schemas/IItemsPerLocationItem'
            },
            type: 'array'
        },
        productParent: {},
        stockLocations: {
            items: {
                '$ref': '#/components/schemas/IStockLocationItem'
            },
            type: 'array'
        }
    },
    required: ['idProduct', 'productName', 'isActive', 'brand', 'productCategory', 'productLowStockAlert', 'productIdealStock', 'tax', 'costCurrency', 'variants'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IItemsPerLocationItem = {
    properties: {
        idLocation: {
            type: 'number',
            format: 'double'
        },
        locationName: {
            type: 'string'
        },
        totalQuantity: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['idLocation', 'locationName', 'totalQuantity'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IStockLocationItem = {
    properties: {
        idProduct: {
            type: 'number',
            format: 'double'
        },
        idLocation: {
            type: 'number',
            format: 'double'
        },
        locationName: {
            type: 'string'
        },
        quantity: {
            type: 'string'
        },
        product: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['idProduct', 'idLocation', 'locationName', 'quantity', 'product'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IProductVariantValue = {
    properties: {
        idProductVariant: {
            type: 'number',
            format: 'double'
        },
        name: {
            type: 'string'
        }
    },
    required: ['idProductVariant', 'name'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IProductVariantType = {
    properties: {
        idProductVariantType: {
            type: 'number',
            format: 'double'
        },
        name: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        productVariantValues: {
            items: {
                '$ref': '#/components/schemas/IProductVariantValue'
            },
            type: 'array'
        }
    },
    required: ['idProductVariantType', 'name', 'productVariantValues'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetAllProductVariantTypesResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IProductVariantType'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreateProductVariantInput = {
    properties: {
        productName: {
            type: 'string'
        },
        productDescription: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        company: {
            type: 'number',
            format: 'double'
        },
        productCategory: {
            type: 'number',
            format: 'double'
        },
        brand: {
            type: 'number',
            format: 'double'
        },
        productSku: {
            type: 'string'
        },
        productBarcode: {
            type: 'string'
        },
        productEan: {
            type: 'string'
        },
        productUpc: {
            type: 'string'
        },
        productGtin: {
            type: 'string'
        },
        productWeight: {
            type: 'number',
            format: 'double'
        },
        productWeightUnit: {
            type: 'string'
        },
        productDimensionUnit: {
            type: 'string'
        },
        productLength: {
            type: 'number',
            format: 'double'
        },
        productWidth: {
            type: 'number',
            format: 'double'
        },
        productHeight: {
            type: 'number',
            format: 'double'
        },
        productDimension: {
            type: 'number',
            format: 'double'
        },
        productImage: {
            type: 'string'
        },
        productVideo: {
            type: 'string'
        },
        productPrice: {
            type: 'number',
            format: 'double'
        },
        productCost: {
            type: 'number',
            format: 'double'
        },
        productLowStockAlert: {
            type: 'number',
            format: 'double'
        },
        productIdealStock: {
            type: 'number',
            format: 'double'
        },
        productModelNumber: {
            type: 'string'
        },
        modelCompatibility: {
            items: {
                type: 'number',
                format: 'double'
            },
            type: 'array'
        },
        warrantyInfo: {
            type: 'string'
        },
        regulatoryCompliance: {
            type: 'string'
        },
        productIdCode: {
            type: 'string'
        },
        productGrade: {
            type: 'string'
        },
        touchScreenCapability: {
            type: 'string'
        },
        productSubcategory: {
            type: 'number',
            format: 'double'
        },
        variantIds: {
            items: {
                type: 'number',
                format: 'double'
            },
            type: 'array'
        },
        locationId: {
            type: 'number',
            format: 'double'
        },
        initialQuantity: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['productName', 'company', 'productCategory', 'brand', 'productBarcode', 'variantIds'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreatePurchaseOrderInputItem = {
    properties: {
        product: {
            type: 'number',
            format: 'double'
        },
        quantity: {
            type: 'number',
            format: 'double'
        },
        unitPrice: {
            type: 'number',
            format: 'double'
        },
        totalPrice: {
            type: 'number',
            format: 'double'
        },
        exchangeRateAmount: {
            type: 'number',
            format: 'double'
        },
        discountScheme: {
            type: 'string'
        },
        discountAmount: {
            type: 'number',
            format: 'double'
        },
        taxAmount: {
            type: 'number',
            format: 'double'
        },
        tax: {
            type: 'number',
            format: 'double'
        },
        currency: {
            type: 'number',
            format: 'double'
        },
        exchangeRate: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['product', 'quantity', 'unitPrice', 'totalPrice'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreatePurchaseOrderInput = {
    properties: {
        purchaseOrderNumber: {
            type: 'string'
        },
        purchaseOrderDate: {
            type: 'string',
            format: 'date-time'
        },
        purchaseOrderDeliveryDate: {
            type: 'string',
            format: 'date-time'
        },
        purchaseOrderNotes: {
            type: 'string'
        },
        status: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        vendor: {
            type: 'number',
            format: 'double'
        },
        company: {
            type: 'number',
            format: 'double'
        },
        financialYear: {
            type: 'number',
            format: 'double'
        },
        assignedTo: {
            type: 'number',
            format: 'double'
        },
        exchangeRateAmount: {
            type: 'number',
            format: 'double'
        },
        discountScheme: {
            type: 'string'
        },
        discountAmount: {
            type: 'number',
            format: 'double'
        },
        shippingChargeTax: {
            type: 'number',
            format: 'double'
        },
        shippingType: {
            type: 'string'
        },
        tax: {
            type: 'number',
            format: 'double'
        },
        currency: {
            type: 'number',
            format: 'double'
        },
        exchangeRate: {
            type: 'number',
            format: 'double'
        },
        totalTaxAmount: {
            type: 'number',
            format: 'double'
        },
        subtotal: {
            type: 'number',
            format: 'double'
        },
        shippingCharge: {
            type: 'number',
            format: 'double'
        },
        discountTotal: {
            type: 'number',
            format: 'double'
        },
        taxTotal: {
            type: 'number',
            format: 'double'
        },
        totalAmount: {
            type: 'number',
            format: 'double'
        },
        purchaseOrderItems: {
            items: {
                '$ref': '#/components/schemas/ICreatePurchaseOrderInputItem'
            },
            type: 'array'
        },
        location: {
            type: 'number',
            format: 'double'
        },
        subject: {
            type: 'string'
        },
        paymentMethod: {
            type: 'number',
            format: 'double'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetPurchaseOrderDetailsResponse = {
    properties: {
        idPurchaseOrder: {
            type: 'number',
            format: 'double'
        },
        purchaseOrderNumber: {
            type: 'string'
        },
        purchaseOrderDate: {
            type: 'string',
            format: 'date-time'
        },
        purchaseOrderDeliveryDate: {
            type: 'string',
            format: 'date-time'
        },
        purchaseOrderNotes: {
            type: 'string'
        },
        status: {
            '$ref': '#/components/schemas/PurchaseOrderStatus'
        },
        isActive: {
            type: 'boolean'
        },
        vendor: {
            '$ref': '#/components/schemas/IVendor'
        },
        exchangeRateAmount: {
            type: 'number',
            format: 'double'
        },
        discountScheme: {
            type: 'string'
        },
        discountAmount: {
            type: 'number',
            format: 'double'
        },
        shippingChargeTax: {
            type: 'number',
            format: 'double'
        },
        currency: {
            '$ref': '#/components/schemas/ICurrency'
        },
        shippingType: {
            type: 'string'
        },
        tax: {
            '$ref': '#/components/schemas/ITaxItem'
        },
        subtotal: {
            type: 'number',
            format: 'double'
        },
        shippingCharge: {
            type: 'number',
            format: 'double'
        },
        discountTotal: {
            type: 'number',
            format: 'double'
        },
        taxTotal: {
            type: 'number',
            format: 'double'
        },
        totalAmount: {
            type: 'number',
            format: 'double'
        },
        purchaseOrderItems: {
            items: {
                '$ref': '#/components/schemas/IPurchaseOrderItem'
            },
            type: 'array'
        },
        location: {
            '$ref': '#/components/schemas/ILocationItem'
        },
        deliveryStatus: {
            '$ref': '#/components/schemas/PurchaseOrderDeliveryStatus'
        },
        subject: {
            type: 'string'
        },
        purchaseOrderHistory: {
            items: {
                '$ref': '#/components/schemas/IPurchaseOrderHistoryItem'
            },
            type: 'array'
        },
        totalPaymentsAmount: {
            type: 'number',
            format: 'double'
        },
        deliveryNote: {
            '$ref': '#/components/schemas/IDeliverNote'
        },
        paymentMethod: {
            '$ref': '#/components/schemas/IPaymentMethodItem'
        }
    },
    required: ['idPurchaseOrder', 'purchaseOrderNumber', 'purchaseOrderDate', 'purchaseOrderDeliveryDate', 'purchaseOrderNotes', 'status', 'isActive', 'vendor', 'exchangeRateAmount', 'subtotal', 'taxTotal', 'totalAmount'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreatePurchaseOrderPaymentInput = {
    properties: {
        purchaseOrderId: {
            type: 'number',
            format: 'double'
        },
        paymentAmount: {
            type: 'number',
            format: 'double'
        },
        paymentDate: {
            type: 'string',
            format: 'date-time'
        },
        paymentAccount: {
            type: 'number',
            format: 'double'
        },
        currency: {
            type: 'number',
            format: 'double'
        },
        exchangeRateAmount: {
            type: 'number',
            format: 'double'
        },
        note: {
            type: 'string'
        },
        referenceNumber: {
            type: 'string'
        },
        paymentMethod: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['purchaseOrderId', 'paymentAmount', 'paymentDate', 'paymentAccount', 'exchangeRateAmount'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdatePurchaseOrderDeliveryStatusInput = {
    properties: {
        deliveryStatus: {
            '$ref': '#/components/schemas/PurchaseOrderDeliveryStatus'
        }
    },
    required: ['deliveryStatus'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreateDeliveryNoteInputItem = {
    properties: {
        quantity: {
            type: 'number',
            format: 'double'
        },
        product: {
            type: 'number',
            format: 'double'
        },
        location: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['quantity', 'product', 'location'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreateDeliveryNoteInput = {
    properties: {
        description: {
            type: 'string'
        },
        deliveryNoteNumber: {
            type: 'string'
        },
        entryDate: {
            type: 'string',
            format: 'date-time'
        },
        deliveryNoteItems: {
            items: {
                '$ref': '#/components/schemas/ICreateDeliveryNoteInputItem'
            },
            type: 'array'
        }
    },
    required: ['description', 'entryDate', 'deliveryNoteItems'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetPurchaseOrderPaymentItem = {
    properties: {
        idPayment: {
            type: 'number',
            format: 'double'
        },
        title: {
            type: 'string'
        },
        paymentNumber: {
            type: 'string'
        },
        note: {
            type: 'string'
        },
        status: {
            type: 'string'
        },
        amount: {
            type: 'number',
            format: 'double'
        },
        entryDate: {
            type: 'string',
            format: 'date-time'
        },
        exchangeRateAmount: {
            type: 'number',
            format: 'double'
        },
        referenceNumber: {
            type: 'string'
        },
        purchaseOrder: {
            '$ref': '#/components/schemas/IPurchaseOrder'
        },
        paymentAccount: {
            '$ref': '#/components/schemas/IAccountItem'
        },
        transaction: {
            type: 'number',
            format: 'double'
        },
        currency: {
            '$ref': '#/components/schemas/ICurrency'
        },
        exchangeRate: {
            '$ref': '#/components/schemas/IExchangeRate'
        },
        financialYear: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['idPayment', 'title', 'paymentNumber', 'note', 'status', 'amount', 'entryDate', 'exchangeRateAmount', 'referenceNumber'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetPurchaseOrderPaymentsResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IGetPurchaseOrderPaymentItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetInventoryTransactionsResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IInventoryTransactionItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        totalInventory: {
            type: 'number',
            format: 'double'
        },
        totalCost: {
            type: 'number',
            format: 'double'
        },
        expectedRevenue: {
            type: 'number',
            format: 'double'
        },
        inventoryChange: {
            type: 'string'
        },
        costChange: {
            type: 'string'
        },
        revenueChange: {
            type: 'string'
        }
    },
    required: ['items', 'total', 'totalInventory', 'totalCost', 'expectedRevenue', 'inventoryChange', 'costChange', 'revenueChange'],
    type: 'object',
    additionalProperties: false
} as const;

export const $InventoryTransactionType = {
    enum: ['RECEIVE', 'ISSUE', 'TRANSFER', 'RETURN', 'LOSS', 'ADJUSTMENT', 'PURCHASE', 'SALE', 'DAMAGE'],
    type: 'string'
} as const;

export const $ICreateInventoryTransactionInput = {
    properties: {
        transactionDate: {
            type: 'string',
            format: 'date-time'
        },
        quantity: {
            type: 'number',
            format: 'double'
        },
        locationFrom: {
            type: 'number',
            format: 'double'
        },
        locationTo: {
            type: 'number',
            format: 'double'
        },
        product: {
            type: 'number',
            format: 'double'
        },
        transactionType: {
            '$ref': '#/components/schemas/InventoryTransactionType'
        },
        inventoryTransactionDescription: {
            type: 'string'
        }
    },
    required: ['transactionDate', 'quantity', 'locationTo', 'transactionType'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IQuickAdjustmentUpdate = {
    properties: {
        productId: {
            type: 'number',
            format: 'double'
        },
        locationId: {
            type: 'number',
            format: 'double'
        },
        targetQuantity: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['productId', 'locationId', 'targetQuantity'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IModelItem = {
    properties: {
        idModel: {
            type: 'number',
            format: 'double'
        },
        modelName: {
            type: 'string'
        },
        modelDescription: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        modelCategory: {
            '$ref': '#/components/schemas/IModelCategoryItem'
        },
        category: {
            '$ref': '#/components/schemas/IModelCategoryItem'
        }
    },
    required: ['idModel', 'modelName', 'modelDescription', 'isActive', 'modelCategory', 'category'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IModelCategoryItem = {
    properties: {
        idModelCategory: {
            type: 'number',
            format: 'double'
        },
        modelCategoryName: {
            type: 'string'
        },
        modelCategoryDescription: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        models: {
            items: {
                '$ref': '#/components/schemas/IModelItem'
            },
            type: 'array'
        }
    },
    required: ['idModelCategory', 'modelCategoryName', 'modelCategoryDescription', 'isActive', 'models'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetModelsResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IModelItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetModelCategoriesResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IModelCategoryItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdateModelInput = {
    properties: {
        modelName: {
            type: 'string'
        },
        modelDescription: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        modelCategory: {
            type: 'number',
            format: 'double'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreateModelCategoryInput = {
    properties: {
        modelCategoryName: {
            type: 'string'
        },
        modelCategoryDescription: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        }
    },
    required: ['modelCategoryName'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdateModelCategoryInput = {
    properties: {
        modelCategoryName: {
            type: 'string'
        },
        modelCategoryDescription: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetStockResponseStockLocations = {
    properties: {
        idLocation: {
            type: 'number',
            format: 'double'
        },
        locationName: {
            type: 'string'
        },
        quantity: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['idLocation', 'locationName', 'quantity'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetStockResponse = {
    properties: {
        idProduct: {
            type: 'number',
            format: 'double'
        },
        productName: {
            type: 'string'
        },
        productDescription: {
            type: 'string'
        },
        productImage: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        productSku: {
            type: 'string'
        },
        productBarcode: {
            type: 'string'
        },
        productEan: {
            type: 'string'
        },
        productUpc: {
            type: 'string'
        },
        productGtin: {
            type: 'string'
        },
        productWeight: {
            type: 'string'
        },
        productWeightUnit: {
            type: 'string'
        },
        productDimensionUnit: {
            type: 'string'
        },
        productLength: {
            type: 'string'
        },
        productWidth: {
            type: 'string'
        },
        productHeight: {
            type: 'string'
        },
        productDimension: {
            type: 'string'
        },
        productPrice: {
            type: 'string'
        },
        productCost: {
            type: 'string'
        },
        productCurrency: {
            type: 'string'
        },
        productStock: {
            type: 'string'
        },
        productStockUnit: {
            type: 'string'
        },
        brand: {
            '$ref': '#/components/schemas/IBrandItem'
        },
        productCategory: {
            '$ref': '#/components/schemas/IProductCategoryItem'
        },
        productLowStockAlert: {
            type: 'number',
            format: 'double'
        },
        productIdealStock: {
            type: 'number',
            format: 'double'
        },
        tax: {
            type: 'number',
            enum: [
                null
            ],
            nullable: true
        },
        costCurrency: {
            type: 'number',
            enum: [
                null
            ],
            nullable: true
        },
        variants: {
            items: {
                '$ref': '#/components/schemas/IProductDetails'
            },
            type: 'array'
        },
        warrantyInfo: {
            type: 'string'
        },
        regulatoryCompliance: {
            type: 'string'
        },
        productIdCode: {
            type: 'string'
        },
        productGrade: {
            type: 'string'
        },
        touchScreenCapability: {
            type: 'string'
        },
        productSubcategory: {
            '$ref': '#/components/schemas/IProductCategoryItem'
        },
        totalQuantity: {
            type: 'number',
            format: 'double'
        },
        stockLocations: {
            items: {
                '$ref': '#/components/schemas/IGetStockResponseStockLocations'
            },
            type: 'array'
        }
    },
    required: ['idProduct', 'productName', 'isActive', 'brand', 'productCategory', 'productLowStockAlert', 'productIdealStock', 'tax', 'costCurrency', 'variants', 'totalQuantity'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetInventoryStockResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IGetStockResponse'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        totalInventory: {
            type: 'number',
            format: 'double'
        },
        totalCost: {
            type: 'number',
            format: 'double'
        },
        expectedRevenue: {
            type: 'number',
            format: 'double'
        },
        inventoryChange: {
            type: 'string'
        },
        costChange: {
            type: 'string'
        },
        revenueChange: {
            type: 'string'
        },
        inventoryStatus: {
            type: 'string'
        },
        costStatus: {
            type: 'string'
        },
        revenueStatus: {
            type: 'string'
        }
    },
    required: ['items', 'total', 'totalInventory', 'totalCost', 'expectedRevenue', 'inventoryChange', 'costChange', 'revenueChange', 'inventoryStatus', 'costStatus', 'revenueStatus'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IInvoiceItem = {
    properties: {
        idInvoiceItem: {
            type: 'number',
            format: 'double'
        },
        quantity: {
            type: 'number',
            format: 'double'
        },
        unitPrice: {
            type: 'number',
            format: 'double'
        },
        totalPrice: {
            type: 'number',
            format: 'double'
        },
        description: {
            type: 'string'
        },
        discountScheme: {
            type: 'string'
        },
        discountAmount: {
            type: 'number',
            format: 'double'
        },
        taxAmount: {
            type: 'number',
            format: 'double'
        },
        tax: {
            type: 'string'
        },
        exchangeRateAmount: {
            type: 'number',
            format: 'double'
        },
        exchangeRate: {
            type: 'number',
            format: 'double'
        },
        currency: {
            type: 'number',
            format: 'double'
        },
        product: {
            '$ref': '#/components/schemas/IProductDetails'
        }
    },
    required: ['idInvoiceItem', 'quantity', 'unitPrice', 'totalPrice'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IInvoice = {
    properties: {
        idInvoice: {
            type: 'number',
            format: 'double'
        },
        invoiceNumber: {
            type: 'string'
        },
        invoiceStatus: {
            type: 'string'
        },
        invoiceDate: {
            type: 'string',
            format: 'date-time'
        },
        invoiceDueDate: {
            type: 'string',
            format: 'date-time'
        },
        invoiceSubtotal: {
            type: 'number',
            format: 'double'
        },
        invoiceDiscountTotal: {
            type: 'number',
            format: 'double'
        },
        invoiceTotalAmount: {
            type: 'number',
            format: 'double'
        },
        isActive: {
            type: 'boolean'
        },
        account: {
            type: 'number',
            format: 'double'
        },
        company: {
            type: 'number',
            format: 'double'
        },
        financialYear: {
            type: 'number',
            format: 'double'
        },
        invoiceItems: {
            items: {
                '$ref': '#/components/schemas/IInvoiceItem'
            },
            type: 'array'
        },
        location: {
            '$ref': '#/components/schemas/ILocationItem'
        },
        paymentMethod: {
            properties: {
                paymentMethodType: {
                    type: 'string'
                },
                paymentMethodName: {
                    type: 'string'
                },
                idPaymentMethod: {
                    type: 'number',
                    format: 'double'
                }
            },
            required: ['paymentMethodName', 'idPaymentMethod'],
            type: 'object'
        }
    },
    required: ['idInvoice', 'invoiceNumber', 'invoiceStatus', 'invoiceDate', 'invoiceDueDate', 'invoiceSubtotal', 'invoiceDiscountTotal', 'invoiceTotalAmount', 'isActive', 'account', 'company', 'financialYear', 'invoiceItems'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IPaymentMethodTotal = {
    properties: {
        name: {
            type: 'string'
        },
        amount: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['name', 'amount'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetInvoicesResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IInvoice'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        totalInvoices: {
            type: 'number',
            format: 'double'
        },
        totalInvoicesAmount: {
            type: 'number',
            format: 'double'
        },
        partialPaidCount: {
            type: 'number',
            format: 'double'
        },
        canceledCount: {
            type: 'number',
            format: 'double'
        },
        paidCount: {
            type: 'number',
            format: 'double'
        },
        notPaidCount: {
            type: 'number',
            format: 'double'
        },
        totalAmountPaid: {
            type: 'number',
            format: 'double'
        },
        totalAmountNotPaid: {
            type: 'number',
            format: 'double'
        },
        paymentMethods: {
            items: {
                '$ref': '#/components/schemas/IPaymentMethodTotal'
            },
            type: 'array'
        }
    },
    required: ['items', 'total', 'totalInvoices', 'totalInvoicesAmount', 'partialPaidCount', 'canceledCount', 'paidCount', 'notPaidCount', 'totalAmountPaid', 'totalAmountNotPaid', 'paymentMethods'],
    type: 'object',
    additionalProperties: false
} as const;

export const $SuccessResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        message: {
            type: 'string'
        },
        data: {}
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $DiscountScheme = {
    enum: ['PERCENTAGE', 'FIXED'],
    type: 'string'
} as const;

export const $InvoiceStatus = {
    enum: ['DRAFT', 'SENT', 'PAID', 'PARTIAL', 'UNPAID', 'OVER_DUE', 'CANCELED'],
    type: 'string'
} as const;

export const $ICreateInvoiceInput = {
    properties: {
        account: {
            type: 'number',
            format: 'double'
        },
        amountPaid: {
            type: 'number',
            format: 'double'
        },
        billingAddress: {
            type: 'string'
        },
        customer: {
            properties: {
                description: {
                    type: 'string'
                },
                website: {
                    type: 'string'
                },
                address: {
                    type: 'string'
                },
                country: {
                    type: 'string'
                },
                phone: {
                    type: 'string'
                },
                email: {
                    type: 'string'
                },
                customerName: {
                    type: 'string'
                },
                idCustomer: {
                    type: 'number',
                    format: 'double'
                }
            },
            required: ['phone', 'email', 'customerName'],
            type: 'object'
        },
        discountAmount: {
            type: 'number',
            format: 'double'
        },
        discountType: {
            '$ref': '#/components/schemas/DiscountScheme'
        },
        invoiceDate: {
            type: 'string'
        },
        invoiceDiscountTotal: {
            type: 'number',
            format: 'double'
        },
        invoiceDueDate: {
            type: 'string'
        },
        invoiceItems: {
            items: {
                properties: {
                    movedFromOtherLocations: {
                        items: {
                            properties: {
                                quantityMoved: {
                                    type: 'number',
                                    format: 'double'
                                },
                                idLocation: {
                                    type: 'number',
                                    format: 'double'
                                }
                            },
                            required: ['quantityMoved', 'idLocation'],
                            type: 'object'
                        },
                        type: 'array'
                    },
                    totalPrice: {
                        type: 'number',
                        format: 'double'
                    },
                    unitPrice: {
                        type: 'number',
                        format: 'double'
                    },
                    quantity: {
                        type: 'number',
                        format: 'double'
                    },
                    product: {
                        type: 'string'
                    }
                },
                required: ['totalPrice', 'unitPrice', 'quantity', 'product'],
                type: 'object'
            },
            type: 'array'
        },
        invoiceNumber: {
            type: 'string'
        },
        invoiceStatus: {
            '$ref': '#/components/schemas/InvoiceStatus'
        },
        invoiceSubtotal: {
            type: 'number',
            format: 'double'
        },
        invoiceTotalAmount: {
            type: 'number',
            format: 'double'
        },
        location: {
            type: 'number',
            format: 'double'
        },
        note: {
            type: 'string'
        },
        tax: {
            type: 'number',
            format: 'double',
            nullable: true
        },
        totalTax: {
            type: 'number',
            format: 'double'
        },
        paymentMethod: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['account', 'customer', 'discountAmount', 'discountType', 'invoiceDate', 'invoiceDiscountTotal', 'invoiceDueDate', 'invoiceItems', 'invoiceStatus', 'invoiceSubtotal', 'invoiceTotalAmount', 'location', 'totalTax'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IInvoiceHistoryDetails = {
    properties: {
        idInvoiceHistory: {
            type: 'number',
            format: 'double'
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        status: {
            type: 'string'
        },
        action: {
            type: 'string'
        },
        entryDate: {
            type: 'string'
        },
        user: {
            type: 'string'
        }
    },
    required: ['idInvoiceHistory', 'title', 'description', 'status', 'action', 'entryDate'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetInvoiceDetailsResponse = {
    properties: {
        idInvoice: {
            type: 'number',
            format: 'double'
        },
        invoiceNumber: {
            type: 'string'
        },
        billingAddress: {
            type: 'string'
        },
        notes: {
            type: 'string'
        },
        invoiceStatus: {
            '$ref': '#/components/schemas/InvoiceStatus'
        },
        invoiceDate: {
            type: 'string'
        },
        invoiceDueDate: {
            type: 'string'
        },
        invoiceSubtotal: {
            type: 'number',
            format: 'double'
        },
        invoiceDiscountTotal: {
            type: 'number',
            format: 'double'
        },
        taxAmount: {
            type: 'number',
            format: 'double'
        },
        invoiceTotalAmount: {
            type: 'number',
            format: 'double'
        },
        isActive: {
            type: 'boolean'
        },
        account: {
            properties: {
                accountGroup: {
                    type: 'string'
                },
                accountName: {
                    type: 'string'
                },
                idAccount: {
                    type: 'number',
                    format: 'double'
                }
            },
            required: ['accountGroup', 'accountName', 'idAccount'],
            type: 'object'
        },
        customer: {
            properties: {
                customerAddress: {
                    type: 'string'
                },
                customerPhone: {
                    type: 'string'
                },
                customerEmail: {
                    type: 'string'
                },
                customerName: {
                    type: 'string'
                },
                idCustomer: {
                    type: 'number',
                    format: 'double'
                }
            },
            required: ['customerAddress', 'customerPhone', 'customerEmail', 'customerName', 'idCustomer'],
            type: 'object'
        },
        tax: {
            properties: {
                taxType: {
                    '$ref': '#/components/schemas/TaxType'
                },
                taxRate: {
                    type: 'number',
                    format: 'double'
                },
                taxName: {
                    type: 'string'
                },
                idTax: {
                    type: 'number',
                    format: 'double'
                }
            },
            required: ['taxType', 'taxRate', 'taxName', 'idTax'],
            type: 'object'
        },
        invoiceItems: {
            items: {
                '$ref': '#/components/schemas/IInvoiceItem'
            },
            type: 'array'
        },
        invoiceHistory: {
            items: {
                '$ref': '#/components/schemas/IInvoiceHistoryDetails'
            },
            type: 'array'
        },
        totalPaidAmount: {
            type: 'number',
            format: 'double'
        },
        discountScheme: {
            type: 'string'
        },
        discountAmount: {
            type: 'number',
            format: 'double'
        },
        totalDiscountAmount: {
            type: 'number',
            format: 'double'
        },
        invoicePayments: {
            items: {
                properties: {
                    paymentMethodEntity: {
                        '$ref': '#/components/schemas/IPaymentMethodItem'
                    },
                    paymentMethod: {
                        type: 'string'
                    },
                    paymentAccount: {
                        type: 'string'
                    },
                    paymentAmount: {
                        type: 'number',
                        format: 'double'
                    },
                    paymentDate: {
                        type: 'string'
                    },
                    paymentId: {
                        type: 'number',
                        format: 'double'
                    }
                },
                required: ['paymentMethod', 'paymentAccount', 'paymentAmount', 'paymentDate', 'paymentId'],
                type: 'object'
            },
            type: 'array'
        },
        paymentMethod: {
            '$ref': '#/components/schemas/IPaymentMethodItem'
        },
        location: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/ILocationItem'
                },
                {
                    type: 'number',
                    format: 'double'
                }
            ]
        }
    },
    required: ['idInvoice', 'invoiceNumber', 'invoiceDate', 'invoiceDueDate', 'invoiceSubtotal', 'invoiceDiscountTotal', 'invoiceTotalAmount', 'invoicePayments'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IInventoryStockReportResponse = {
    properties: {
        items: {
            items: {
                properties: {
                    stockValue: {
                        type: 'number',
                        format: 'double'
                    },
                    locationName: {
                        type: 'string'
                    },
                    quantityOnHand: {
                        type: 'number',
                        format: 'double'
                    },
                    sku: {
                        type: 'string'
                    },
                    productName: {
                        type: 'string'
                    },
                    productId: {
                        type: 'string'
                    }
                },
                required: ['stockValue', 'locationName', 'quantityOnHand', 'sku', 'productName', 'productId'],
                type: 'object'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IInventoryStockReportInput = {
    properties: {
        filters: {
            type: 'string'
        },
        sort: {
            type: 'string'
        },
        pagination: {
            type: 'string'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $IDashboardOverviewResponse = {
    properties: {
        totalRevenue: {
            type: 'number',
            format: 'double'
        },
        totalRevenueChangePercentage: {
            type: 'number',
            format: 'double'
        },
        totalExpenses: {
            type: 'number',
            format: 'double'
        },
        totalExpensesChangePercentage: {
            type: 'number',
            format: 'double'
        },
        totalInventory: {
            type: 'number',
            format: 'double'
        },
        totalInventoryChangePercentage: {
            type: 'number',
            format: 'double'
        },
        totalSales: {
            type: 'number',
            format: 'double'
        },
        totalSalesChangePercentage: {
            type: 'number',
            format: 'double'
        },
        upcomingPayments: {
            items: {
                properties: {
                    dueDate: {
                        type: 'string'
                    },
                    amountRemaining: {
                        type: 'string'
                    },
                    purchaseOrderNumber: {
                        type: 'string'
                    },
                    purchaseOrderId: {
                        type: 'number',
                        format: 'double'
                    }
                },
                required: ['dueDate', 'amountRemaining', 'purchaseOrderNumber', 'purchaseOrderId'],
                type: 'object'
            },
            type: 'array'
        },
        purchaseVsSales: {
            items: {
                properties: {
                    date: {
                        type: 'string'
                    },
                    sales: {
                        type: 'number',
                        format: 'double'
                    },
                    purchases: {
                        type: 'number',
                        format: 'double'
                    }
                },
                required: ['date', 'sales', 'purchases'],
                type: 'object'
            },
            type: 'array'
        },
        expenses: {
            items: {
                properties: {
                    total: {
                        type: 'number',
                        format: 'double'
                    },
                    expenseCategory: {
                        type: 'string'
                    }
                },
                required: ['total', 'expenseCategory'],
                type: 'object'
            },
            type: 'array'
        },
        lowInventoryProducts: {
            items: {
                properties: {
                    quantityOnHand: {
                        type: 'number',
                        format: 'double'
                    },
                    productName: {
                        type: 'string'
                    },
                    idProduct: {
                        type: 'number',
                        format: 'double'
                    }
                },
                required: ['quantityOnHand', 'productName', 'idProduct'],
                type: 'object'
            },
            type: 'array'
        },
        noMovementInventoryProducts: {
            items: {
                properties: {
                    quantityOnHand: {
                        type: 'number',
                        format: 'double'
                    },
                    productName: {
                        type: 'string'
                    },
                    idProduct: {
                        type: 'number',
                        format: 'double'
                    }
                },
                required: ['quantityOnHand', 'productName', 'idProduct'],
                type: 'object'
            },
            type: 'array'
        },
        lowInventoryProductsPaginationTotal: {
            type: 'number',
            format: 'double'
        },
        noMovementInventoryProductsPaginationTotal: {
            type: 'number',
            format: 'double'
        },
        cashFlow: {
            items: {
                properties: {
                    label: {
                        type: 'string'
                    },
                    value: {
                        type: 'number',
                        format: 'double'
                    },
                    type: {
                        type: 'string'
                    }
                },
                required: ['label', 'value', 'type'],
                type: 'object'
            },
            type: 'array'
        },
        lowQuantityProducts: {
            items: {
                properties: {
                    totalQuantity: {
                        type: 'number',
                        format: 'double'
                    },
                    productSku: {
                        type: 'string',
                        nullable: true
                    },
                    productSubcategory: {
                        type: 'string',
                        nullable: true
                    },
                    productCategory: {
                        type: 'string'
                    },
                    brand: {
                        type: 'string'
                    },
                    productName: {
                        type: 'string'
                    },
                    idProduct: {
                        type: 'number',
                        format: 'double'
                    }
                },
                required: ['totalQuantity', 'productSku', 'productSubcategory', 'productCategory', 'brand', 'productName', 'idProduct'],
                type: 'object'
            },
            type: 'array'
        },
        noMovementProducts: {
            items: {
                properties: {
                    totalQuantity: {
                        type: 'number',
                        format: 'double'
                    },
                    productSku: {
                        type: 'string',
                        nullable: true
                    },
                    productSubcategory: {
                        type: 'string',
                        nullable: true
                    },
                    productCategory: {
                        type: 'string'
                    },
                    brand: {
                        type: 'string'
                    },
                    productName: {
                        type: 'string'
                    },
                    idProduct: {
                        type: 'number',
                        format: 'double'
                    }
                },
                required: ['totalQuantity', 'productSku', 'productSubcategory', 'productCategory', 'brand', 'productName', 'idProduct'],
                type: 'object'
            },
            type: 'array'
        }
    },
    required: ['totalRevenue', 'totalRevenueChangePercentage', 'totalExpenses', 'totalExpensesChangePercentage', 'totalInventory', 'totalInventoryChangePercentage', 'totalSales', 'totalSalesChangePercentage', 'upcomingPayments', 'purchaseVsSales', 'expenses', 'lowInventoryProducts', 'noMovementInventoryProducts', 'lowInventoryProductsPaginationTotal', 'noMovementInventoryProductsPaginationTotal', 'cashFlow', 'lowQuantityProducts', 'noMovementProducts'],
    type: 'object',
    additionalProperties: false
} as const;

export const $GetDownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        message: {
            type: 'string'
        },
        downloadUrl: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $TopSellingProductResult = {
    properties: {
        productId: {
            type: 'number',
            format: 'double'
        },
        productName: {
            type: 'string'
        },
        brandName: {
            type: 'string'
        },
        categoryName: {
            type: 'string'
        },
        quantitySold: {
            type: 'number',
            format: 'double'
        },
        totalRevenue: {
            type: 'number',
            format: 'double'
        },
        brand: {
            type: 'string'
        },
        category: {
            type: 'string'
        }
    },
    required: ['productId', 'productName', 'quantitySold', 'totalRevenue', 'brand', 'category'],
    type: 'object',
    additionalProperties: false
} as const;

export const $SalesSummaryByPeriod = {
    properties: {
        period: {
            type: 'string'
        },
        totalAmount: {
            type: 'number',
            format: 'double'
        },
        invoiceCount: {
            type: 'number',
            format: 'double'
        },
        averageInvoiceValue: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['period', 'totalAmount', 'invoiceCount', 'averageInvoiceValue'],
    type: 'object',
    additionalProperties: false
} as const;

export const $SalesSummaryResponse = {
    properties: {
        totalSales: {
            type: 'number',
            format: 'double'
        },
        totalInvoices: {
            type: 'number',
            format: 'double'
        },
        averageInvoiceValue: {
            type: 'number',
            format: 'double'
        },
        topSellingProducts: {
            items: {
                '$ref': '#/components/schemas/TopSellingProductResult'
            },
            type: 'array'
        },
        periodSummaries: {
            items: {
                '$ref': '#/components/schemas/SalesSummaryByPeriod'
            },
            type: 'array'
        }
    },
    required: ['totalSales', 'totalInvoices', 'averageInvoiceValue', 'topSellingProducts', 'periodSummaries'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ProductSalesSummary = {
    properties: {
        productId: {
            type: 'number',
            format: 'double'
        },
        productName: {
            type: 'string'
        },
        categoryName: {
            type: 'string'
        },
        subCategoryName: {
            type: 'string'
        },
        brandName: {
            type: 'string'
        },
        sku: {
            type: 'string'
        },
        quantitySold: {
            type: 'number',
            format: 'double'
        },
        totalRevenue: {
            type: 'number',
            format: 'double'
        },
        profitMargin: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['productId', 'productName', 'categoryName', 'subCategoryName', 'brandName', 'sku', 'quantitySold', 'totalRevenue', 'profitMargin'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ProductSalesSummaryResponse = {
    properties: {
        productsSales: {
            items: {
                '$ref': '#/components/schemas/ProductSalesSummary'
            },
            type: 'array'
        },
        totals: {
            properties: {
                averageProfitMargin: {
                    type: 'number',
                    format: 'double'
                },
                totalRevenue: {
                    type: 'number',
                    format: 'double'
                },
                totalQuantitySold: {
                    type: 'number',
                    format: 'double'
                }
            },
            required: ['averageProfitMargin', 'totalRevenue', 'totalQuantitySold'],
            type: 'object'
        },
        filters: {
            properties: {
                endDate: {
                    type: 'string'
                },
                startDate: {
                    type: 'string'
                }
            },
            required: ['endDate', 'startDate'],
            type: 'object'
        }
    },
    required: ['productsSales', 'totals', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $CustomerSalesSummary = {
    properties: {
        customerName: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        phone: {
            type: 'string'
        },
        totalPurchases: {
            type: 'number',
            format: 'double'
        },
        averageInvoiceValue: {
            type: 'number',
            format: 'double'
        },
        lastPurchaseDate: {
            type: 'string',
            nullable: true
        },
        lastPurchaseAmount: {
            type: 'number',
            format: 'double'
        },
        invoiceCount: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['customerName', 'email', 'phone', 'totalPurchases', 'averageInvoiceValue', 'lastPurchaseDate', 'lastPurchaseAmount', 'invoiceCount'],
    type: 'object',
    additionalProperties: false
} as const;

export const $CustomerSalesSummaryResponse = {
    properties: {
        customers: {
            items: {
                '$ref': '#/components/schemas/CustomerSalesSummary'
            },
            type: 'array'
        },
        filters: {
            properties: {
                endDate: {
                    type: 'string'
                },
                startDate: {
                    type: 'string'
                }
            },
            required: ['endDate', 'startDate'],
            type: 'object'
        }
    },
    required: ['customers', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $EmployeeInvoiceSummary = {
    properties: {
        employeeName: {
            type: 'string'
        },
        invoiceCount: {
            type: 'number',
            format: 'double'
        },
        totalRevenue: {
            type: 'number',
            format: 'double'
        },
        averageInvoiceValue: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['employeeName', 'invoiceCount', 'totalRevenue', 'averageInvoiceValue'],
    type: 'object',
    additionalProperties: false
} as const;

export const $EmployeeInvoiceSummaryResponse = {
    properties: {
        employees: {
            items: {
                '$ref': '#/components/schemas/EmployeeInvoiceSummary'
            },
            type: 'array'
        },
        filters: {
            properties: {
                endDate: {
                    type: 'string'
                },
                startDate: {
                    type: 'string'
                }
            },
            required: ['endDate', 'startDate'],
            type: 'object'
        }
    },
    required: ['employees', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IWarehouseStockReportResponse = {
    properties: {
        kpis: {
            properties: {
                totalQuantity: {
                    type: 'number',
                    format: 'double'
                },
                totalActiveProducts: {
                    type: 'number',
                    format: 'double'
                },
                totalLocations: {
                    type: 'number',
                    format: 'double'
                }
            },
            required: ['totalQuantity', 'totalActiveProducts', 'totalLocations'],
            type: 'object'
        },
        locations: {
            items: {
                properties: {
                    totalQuantity: {
                        type: 'number',
                        format: 'double'
                    },
                    totalProducts: {
                        type: 'number',
                        format: 'double'
                    },
                    isActive: {
                        type: 'boolean'
                    },
                    locationType: {
                        type: 'string'
                    },
                    locationName: {
                        type: 'string'
                    },
                    locationId: {
                        type: 'number',
                        format: 'double'
                    }
                },
                required: ['totalQuantity', 'totalProducts', 'isActive', 'locationType', 'locationName', 'locationId'],
                type: 'object'
            },
            type: 'array'
        },
        pagination: {
            properties: {
                offset: {
                    type: 'number',
                    format: 'double'
                },
                limit: {
                    type: 'number',
                    format: 'double'
                },
                total: {
                    type: 'number',
                    format: 'double'
                }
            },
            required: ['offset', 'limit', 'total'],
            type: 'object'
        },
        filters: {
            properties: {
                isActive: {
                    type: 'boolean'
                },
                locationType: {
                    type: 'string'
                }
            },
            type: 'object'
        }
    },
    required: ['kpis', 'locations', 'pagination', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IInventoryTransactionsReportItem = {
    properties: {
        transactionId: {
            type: 'number',
            format: 'double'
        },
        transactionType: {
            type: 'string'
        },
        productId: {
            type: 'number',
            format: 'double'
        },
        productName: {
            type: 'string'
        },
        sku: {
            type: 'string'
        },
        quantity: {
            type: 'number',
            format: 'double'
        },
        locationFrom: {
            type: 'string',
            nullable: true
        },
        locationTo: {
            type: 'string',
            nullable: true
        },
        createdAt: {
            type: 'string'
        },
        brandName: {
            type: 'string',
            nullable: true
        },
        productCategoryName: {
            type: 'string',
            nullable: true
        },
        productSubcategoryName: {
            type: 'string',
            nullable: true
        },
        reference: {
            type: 'string',
            nullable: true
        },
        userName: {
            type: 'string',
            nullable: true
        }
    },
    required: ['transactionId', 'transactionType', 'productId', 'productName', 'sku', 'quantity', 'createdAt'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IInventoryTransactionsReportKPI = {
    properties: {
        totalTransactions: {
            type: 'number',
            format: 'double'
        },
        totalQuantity: {
            type: 'number',
            format: 'double'
        },
        totalProducts: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalTransactions', 'totalQuantity', 'totalProducts'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IInventoryTransactionsReportResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IInventoryTransactionsReportItem'
            },
            type: 'array'
        },
        kpis: {
            '$ref': '#/components/schemas/IInventoryTransactionsReportKPI'
        },
        pagination: {
            properties: {
                offset: {
                    type: 'number',
                    format: 'double'
                },
                limit: {
                    type: 'number',
                    format: 'double'
                },
                total: {
                    type: 'number',
                    format: 'double'
                }
            },
            required: ['offset', 'limit', 'total'],
            type: 'object'
        },
        filters: {
            properties: {
                locationId: {
                    type: 'number',
                    format: 'double'
                },
                productId: {
                    type: 'number',
                    format: 'double'
                },
                endDate: {
                    type: 'string'
                },
                startDate: {
                    type: 'string'
                },
                transactionType: {
                    type: 'string'
                }
            },
            type: 'object'
        }
    },
    required: ['items', 'kpis', 'pagination', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $InventoryTransactionsReportDownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ILowStockAlertReportItem = {
    properties: {
        productId: {
            type: 'number',
            format: 'double'
        },
        productName: {
            type: 'string'
        },
        categoryName: {
            type: 'string'
        },
        subCategoryName: {
            type: 'string',
            nullable: true
        },
        brandName: {
            type: 'string'
        },
        sku: {
            type: 'string'
        },
        quantity: {
            type: 'number',
            format: 'double'
        },
        minimumRequired: {
            type: 'number',
            format: 'double'
        },
        stockLevelPercentage: {
            type: 'number',
            format: 'double'
        },
        status: {
            type: 'string',
            enum: ['CRITICAL', 'WARNING', 'OK']
        },
        restockCost: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['productId', 'productName', 'categoryName', 'subCategoryName', 'brandName', 'sku', 'quantity', 'minimumRequired', 'stockLevelPercentage', 'status', 'restockCost'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ILowStockAlertReportKPI = {
    properties: {
        totalLowStock: {
            type: 'number',
            format: 'double'
        },
        totalCritical: {
            type: 'number',
            format: 'double'
        },
        totalWarning: {
            type: 'number',
            format: 'double'
        },
        estimatedRestockCost: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalLowStock', 'totalCritical', 'totalWarning', 'estimatedRestockCost'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ILowStockAlertReportResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/ILowStockAlertReportItem'
            },
            type: 'array'
        },
        kpis: {
            '$ref': '#/components/schemas/ILowStockAlertReportKPI'
        },
        pagination: {
            properties: {
                offset: {
                    type: 'number',
                    format: 'double'
                },
                limit: {
                    type: 'number',
                    format: 'double'
                },
                total: {
                    type: 'number',
                    format: 'double'
                }
            },
            required: ['offset', 'limit', 'total'],
            type: 'object'
        }
    },
    required: ['items', 'kpis', 'pagination'],
    type: 'object',
    additionalProperties: false
} as const;

export const $LowStockAlertReportDownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IStockValuationReportItem = {
    properties: {
        productId: {
            type: 'number',
            format: 'double'
        },
        productName: {
            type: 'string'
        },
        categoryName: {
            type: 'string'
        },
        subCategoryName: {
            type: 'string',
            nullable: true
        },
        brandName: {
            type: 'string'
        },
        sku: {
            type: 'string'
        },
        quantity: {
            type: 'number',
            format: 'double'
        },
        totalSellingPrice: {
            type: 'number',
            format: 'double'
        },
        totalBuyingPrice: {
            type: 'number',
            format: 'double'
        },
        totalValuation: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['productId', 'productName', 'categoryName', 'subCategoryName', 'brandName', 'sku', 'quantity', 'totalSellingPrice', 'totalBuyingPrice', 'totalValuation'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IStockValuationReportKPI = {
    properties: {
        totalProducts: {
            type: 'number',
            format: 'double'
        },
        totalQuantity: {
            type: 'number',
            format: 'double'
        },
        totalValuation: {
            type: 'number',
            format: 'double'
        },
        totalSellingPrice: {
            type: 'number',
            format: 'double'
        },
        totalBuyingPrice: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalProducts', 'totalQuantity', 'totalValuation', 'totalSellingPrice', 'totalBuyingPrice'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IStockValuationReportResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IStockValuationReportItem'
            },
            type: 'array'
        },
        kpis: {
            '$ref': '#/components/schemas/IStockValuationReportKPI'
        },
        pagination: {
            properties: {
                offset: {
                    type: 'number',
                    format: 'double'
                },
                limit: {
                    type: 'number',
                    format: 'double'
                },
                total: {
                    type: 'number',
                    format: 'double'
                }
            },
            required: ['offset', 'limit', 'total'],
            type: 'object'
        },
        filters: {
            properties: {
                search: {
                    type: 'string'
                }
            },
            type: 'object'
        }
    },
    required: ['items', 'kpis', 'pagination', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $StockValuationReportDownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IStockMovementReportItem = {
    properties: {
        idInventoryTransaction: {
            type: 'number',
            format: 'double'
        },
        productName: {
            type: 'string'
        },
        productCategoryName: {
            type: 'string'
        },
        productSubcategoryName: {
            type: 'string'
        },
        productBrand: {
            type: 'string'
        },
        productSku: {
            type: 'string'
        },
        source: {
            type: 'string'
        },
        date: {
            type: 'string',
            format: 'date-time'
        },
        quantity: {
            type: 'number',
            format: 'double'
        },
        movementType: {
            type: 'string',
            enum: ['incoming', 'outgoing']
        },
        remarks: {
            type: 'string'
        },
        locationName: {
            type: 'string'
        },
        invoiceNumber: {
            type: 'string'
        },
        purchaseOrderNumber: {
            type: 'string'
        }
    },
    required: ['idInventoryTransaction', 'productName', 'source', 'date', 'quantity', 'movementType'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IStockMovementReportKpis = {
    properties: {
        totalMovements: {
            type: 'number',
            format: 'double'
        },
        totalIncoming: {
            type: 'number',
            format: 'double'
        },
        totalOutgoing: {
            type: 'number',
            format: 'double'
        },
        totalQuantityIncoming: {
            type: 'number',
            format: 'double'
        },
        totalQuantityOutgoing: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalMovements', 'totalIncoming', 'totalOutgoing', 'totalQuantityIncoming', 'totalQuantityOutgoing'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IStockMovementReportResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IStockMovementReportItem'
            },
            type: 'array'
        },
        kpis: {
            '$ref': '#/components/schemas/IStockMovementReportKpis'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        limit: {
            type: 'number',
            format: 'double'
        },
        offset: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'kpis', 'total', 'limit', 'offset'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IPurchaseOrderReportItem = {
    properties: {
        purchaseOrderId: {
            type: 'number',
            format: 'double'
        },
        purchaseOrderNumber: {
            type: 'string'
        },
        purchaseOrderDate: {
            type: 'string'
        },
        vendorId: {
            type: 'number',
            format: 'double'
        },
        vendorName: {
            type: 'string'
        },
        totalValue: {
            type: 'number',
            format: 'double'
        },
        estimatedRevenue: {
            type: 'number',
            format: 'double'
        },
        status: {
            type: 'string'
        },
        deliveryStatus: {
            type: 'string'
        },
        productNames: {
            items: {
                type: 'string'
            },
            type: 'array'
        }
    },
    required: ['purchaseOrderId', 'purchaseOrderNumber', 'purchaseOrderDate', 'vendorId', 'vendorName', 'totalValue', 'estimatedRevenue', 'status', 'deliveryStatus', 'productNames'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IPurchaseOrderReportKPI = {
    properties: {
        totalOrders: {
            type: 'number',
            format: 'double'
        },
        totalVendors: {
            type: 'number',
            format: 'double'
        },
        totalValue: {
            type: 'number',
            format: 'double'
        },
        totalEstimatedRevenue: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalOrders', 'totalVendors', 'totalValue', 'totalEstimatedRevenue'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IPurchaseOrderReportResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IPurchaseOrderReportItem'
            },
            type: 'array'
        },
        kpis: {
            '$ref': '#/components/schemas/IPurchaseOrderReportKPI'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        limit: {
            type: 'number',
            format: 'double'
        },
        offset: {
            type: 'number',
            format: 'double'
        },
        filters: {
            properties: {
                search: {
                    type: 'string'
                },
                endDate: {
                    type: 'string'
                },
                startDate: {
                    type: 'string'
                }
            },
            type: 'object'
        }
    },
    required: ['items', 'kpis', 'total', 'limit', 'offset', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $PurchaseOrderReportDownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IPurchaseReportItem = {
    properties: {
        purchaseOrderItemId: {
            type: 'number',
            format: 'double'
        },
        purchaseOrderId: {
            type: 'number',
            format: 'double'
        },
        purchaseOrderNumber: {
            type: 'string'
        },
        purchaseOrderDate: {
            type: 'string'
        },
        vendorId: {
            type: 'number',
            format: 'double'
        },
        vendorName: {
            type: 'string'
        },
        productId: {
            type: 'number',
            format: 'double'
        },
        productName: {
            type: 'string'
        },
        productSku: {
            type: 'string'
        },
        productBarcode: {
            type: 'string'
        },
        category: {
            type: 'string',
            nullable: true
        },
        subCategory: {
            type: 'string',
            nullable: true
        },
        brand: {
            type: 'string',
            nullable: true
        },
        buyingPrice: {
            type: 'number',
            format: 'double'
        },
        sellingPrice: {
            type: 'number',
            format: 'double'
        },
        quantity: {
            type: 'number',
            format: 'double'
        },
        estimatedRevenue: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['purchaseOrderItemId', 'purchaseOrderId', 'purchaseOrderNumber', 'purchaseOrderDate', 'vendorId', 'vendorName', 'productId', 'productName', 'productSku', 'productBarcode', 'category', 'subCategory', 'brand', 'buyingPrice', 'sellingPrice', 'quantity', 'estimatedRevenue'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IPurchaseReportKPI = {
    properties: {
        totalItems: {
            type: 'number',
            format: 'double'
        },
        totalVendors: {
            type: 'number',
            format: 'double'
        },
        totalValue: {
            type: 'number',
            format: 'double'
        },
        totalEstimatedRevenue: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalItems', 'totalVendors', 'totalValue', 'totalEstimatedRevenue'],
    type: 'object',
    additionalProperties: false
} as const;

export const $Record_string_any_ = {
    properties: {},
    additionalProperties: {},
    type: 'object',
    description: 'Construct a type with a set of properties K of type T'
} as const;

export const $IPurchaseReportResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IPurchaseReportItem'
            },
            type: 'array'
        },
        kpis: {
            '$ref': '#/components/schemas/IPurchaseReportKPI'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        limit: {
            type: 'number',
            format: 'double'
        },
        offset: {
            type: 'number',
            format: 'double'
        },
        filters: {
            '$ref': '#/components/schemas/Record_string.any_'
        }
    },
    required: ['items', 'kpis', 'total', 'limit', 'offset', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $PurchaseReportDownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IProfitLossItem = {
    properties: {
        accountId: {
            type: 'number',
            format: 'double'
        },
        accountName: {
            type: 'string'
        },
        accountNumber: {
            type: 'string'
        },
        amount: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['accountId', 'accountName', 'amount'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IProfitLossGroup = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IProfitLossItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IProfitLossSubtype = {
    properties: {
        groups: {
            properties: {},
            additionalProperties: {
                '$ref': '#/components/schemas/IProfitLossGroup'
            },
            type: 'object'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['groups', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IProfitLossSection = {
    properties: {
        subtypes: {
            properties: {},
            additionalProperties: {
                '$ref': '#/components/schemas/IProfitLossSubtype'
            },
            type: 'object'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['subtypes', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IProfitLossStatementResponse = {
    properties: {
        revenue: {
            '$ref': '#/components/schemas/IProfitLossSection'
        },
        expenses: {
            '$ref': '#/components/schemas/IProfitLossSection'
        },
        summary: {
            properties: {
                netIncome: {
                    type: 'number',
                    format: 'double'
                },
                grossProfit: {
                    type: 'number',
                    format: 'double'
                },
                totalExpenses: {
                    type: 'number',
                    format: 'double'
                },
                totalRevenue: {
                    type: 'number',
                    format: 'double'
                }
            },
            required: ['netIncome', 'grossProfit', 'totalExpenses', 'totalRevenue'],
            type: 'object'
        },
        reportInfo: {
            properties: {
                baseCurrency: {
                    type: 'string'
                },
                generatedAt: {
                    type: 'string'
                },
                endDate: {
                    type: 'string'
                },
                startDate: {
                    type: 'string'
                }
            },
            required: ['baseCurrency', 'generatedAt', 'endDate', 'startDate'],
            type: 'object'
        }
    },
    required: ['revenue', 'expenses', 'summary', 'reportInfo'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ProfitLossStatementDownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IAccountingTransactionReportItem = {
    properties: {
        transactionId: {
            type: 'number',
            format: 'double'
        },
        transactionNumber: {
            type: 'string'
        },
        transactionType: {
            type: 'string'
        },
        amount: {
            type: 'number',
            format: 'double'
        },
        transactionDate: {
            type: 'string'
        },
        notes: {
            type: 'string'
        },
        transactionDescription: {
            type: 'string'
        },
        debitAccountId: {
            type: 'number',
            format: 'double'
        },
        debitAccountName: {
            type: 'string'
        },
        debitAccountNumber: {
            type: 'string'
        },
        creditAccountId: {
            type: 'number',
            format: 'double'
        },
        creditAccountName: {
            type: 'string'
        },
        creditAccountNumber: {
            type: 'string'
        },
        currency: {
            type: 'string'
        }
    },
    required: ['transactionId', 'transactionNumber', 'transactionType', 'amount', 'transactionDate'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IAccountingTransactionReportKPI = {
    properties: {
        totalTransactions: {
            type: 'number',
            format: 'double'
        },
        totalAmount: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalTransactions', 'totalAmount'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IAccountingTransactionReportResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IAccountingTransactionReportItem'
            },
            type: 'array'
        },
        kpis: {
            '$ref': '#/components/schemas/IAccountingTransactionReportKPI'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        limit: {
            type: 'number',
            format: 'double'
        },
        offset: {
            type: 'number',
            format: 'double'
        },
        filters: {
            properties: {
                endDate: {
                    type: 'string'
                },
                startDate: {
                    type: 'string'
                },
                search: {
                    type: 'string'
                }
            },
            type: 'object'
        }
    },
    required: ['items', 'kpis', 'total', 'limit', 'offset', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $AccountingTransactionReportDownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IExpenseReportItem = {
    properties: {
        expenseId: {
            type: 'number',
            format: 'double'
        },
        expenseName: {
            type: 'string'
        },
        expenseDescription: {
            type: 'string'
        },
        expenseAmount: {
            type: 'number',
            format: 'double'
        },
        expenseDate: {
            type: 'string'
        },
        categoryId: {
            type: 'number',
            format: 'double'
        },
        categoryName: {
            type: 'string'
        },
        categoryIcon: {
            type: 'string'
        }
    },
    required: ['expenseId', 'expenseAmount', 'expenseDate'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IExpenseReportKPI = {
    properties: {
        totalExpenses: {
            type: 'number',
            format: 'double'
        },
        totalAmount: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalExpenses', 'totalAmount'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IExpenseReportResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IExpenseReportItem'
            },
            type: 'array'
        },
        kpis: {
            '$ref': '#/components/schemas/IExpenseReportKPI'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        limit: {
            type: 'number',
            format: 'double'
        },
        offset: {
            type: 'number',
            format: 'double'
        },
        filters: {
            properties: {
                endDate: {
                    type: 'string'
                },
                startDate: {
                    type: 'string'
                },
                search: {
                    type: 'string'
                }
            },
            type: 'object'
        }
    },
    required: ['items', 'kpis', 'total', 'limit', 'offset', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ExpenseReportDownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IAuditLog2ReportItem = {
    properties: {
        idAuditLog2: {
            type: 'number',
            format: 'double'
        },
        title: {
            type: 'string'
        },
        body: {
            type: 'string'
        },
        url: {
            type: 'string'
        },
        method: {
            type: 'string'
        },
        userId: {
            type: 'number',
            format: 'double'
        },
        username: {
            type: 'string'
        },
        queryParams: {},
        params: {},
        timestamp: {
            type: 'string'
        },
        module: {
            type: 'string'
        },
        ipAddress: {
            type: 'string'
        }
    },
    required: ['idAuditLog2', 'title', 'body', 'url', 'method', 'userId', 'username'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IAuditLog2ReportKPI = {
    properties: {
        totalLogs: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalLogs'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IAuditLog2ReportResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IAuditLog2ReportItem'
            },
            type: 'array'
        },
        kpis: {
            '$ref': '#/components/schemas/IAuditLog2ReportKPI'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        limit: {
            type: 'number',
            format: 'double'
        },
        offset: {
            type: 'number',
            format: 'double'
        },
        filters: {
            properties: {
                endDate: {
                    type: 'string'
                },
                startDate: {
                    type: 'string'
                },
                search: {
                    type: 'string'
                }
            },
            type: 'object'
        }
    },
    required: ['items', 'kpis', 'total', 'limit', 'offset', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $AuditLog2ReportDownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IRevenueByUserReportItem = {
    properties: {
        userId: {
            type: 'number',
            format: 'double'
        },
        userName: {
            type: 'string'
        },
        userFullName: {
            type: 'string'
        },
        userEmail: {
            type: 'string'
        },
        userPhone: {
            type: 'string'
        },
        totalRevenue: {
            type: 'number',
            format: 'double'
        },
        invoiceCount: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['userId', 'userName', 'userFullName', 'userEmail', 'totalRevenue', 'invoiceCount'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IRevenueByUserReportKPI = {
    properties: {
        totalRevenue: {
            type: 'number',
            format: 'double'
        },
        totalUsers: {
            type: 'number',
            format: 'double'
        },
        totalInvoices: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalRevenue', 'totalUsers', 'totalInvoices'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IRevenueByUserReportResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IRevenueByUserReportItem'
            },
            type: 'array'
        },
        kpis: {
            '$ref': '#/components/schemas/IRevenueByUserReportKPI'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        limit: {
            type: 'number',
            format: 'double'
        },
        offset: {
            type: 'number',
            format: 'double'
        },
        filters: {
            properties: {
                endDate: {
                    type: 'string'
                },
                startDate: {
                    type: 'string'
                },
                search: {
                    type: 'string'
                }
            },
            type: 'object'
        }
    },
    required: ['items', 'kpis', 'total', 'limit', 'offset', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $RevenueByUserReportDownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICustomerReportItemV2 = {
    properties: {
        customerId: {
            type: 'number',
            format: 'double'
        },
        customerName: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        country: {
            type: 'string'
        },
        address: {
            type: 'string'
        },
        phone: {
            type: 'string'
        },
        mobilePhone: {
            type: 'string'
        },
        whatsappPhone: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        website: {
            type: 'string'
        },
        wechatID: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        totalInvoices: {
            type: 'number',
            format: 'double'
        },
        totalRevenue: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['customerId', 'customerName', 'isActive', 'totalInvoices', 'totalRevenue'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICustomerReportKPIV2 = {
    properties: {
        totalCustomers: {
            type: 'number',
            format: 'double'
        },
        totalRevenue: {
            type: 'number',
            format: 'double'
        },
        totalInvoices: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalCustomers', 'totalRevenue', 'totalInvoices'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICustomerReportV2Response = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/ICustomerReportItemV2'
            },
            type: 'array'
        },
        kpis: {
            '$ref': '#/components/schemas/ICustomerReportKPIV2'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        limit: {
            type: 'number',
            format: 'double'
        },
        offset: {
            type: 'number',
            format: 'double'
        },
        filters: {
            properties: {
                endDate: {
                    type: 'string'
                },
                startDate: {
                    type: 'string'
                },
                search: {
                    type: 'string'
                }
            },
            additionalProperties: {},
            type: 'object'
        }
    },
    required: ['items', 'kpis', 'total', 'limit', 'offset', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $CustomerReportDownloadV2Response = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IBalanceSheetAccountItem = {
    properties: {
        accountId: {
            type: 'number',
            format: 'double'
        },
        accountName: {
            type: 'string'
        },
        accountNumber: {
            type: 'string'
        },
        accountType: {
            type: 'string'
        },
        accountSubtype: {
            type: 'string'
        },
        accountGroup: {
            type: 'string'
        },
        accountSubGroup: {
            type: 'string'
        },
        balance: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['accountId', 'accountName', 'accountType', 'accountSubtype', 'accountGroup', 'balance'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IBalanceSheetGroup = {
    properties: {
        groupName: {
            type: 'string'
        },
        accounts: {
            items: {
                '$ref': '#/components/schemas/IBalanceSheetAccountItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['groupName', 'accounts', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IBalanceSheetSection = {
    properties: {
        sectionName: {
            type: 'string'
        },
        groups: {
            items: {
                '$ref': '#/components/schemas/IBalanceSheetGroup'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['sectionName', 'groups', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IBalanceSheetV2Response = {
    properties: {
        assets: {
            items: {
                '$ref': '#/components/schemas/IBalanceSheetSection'
            },
            type: 'array'
        },
        liabilities: {
            items: {
                '$ref': '#/components/schemas/IBalanceSheetSection'
            },
            type: 'array'
        },
        equity: {
            items: {
                '$ref': '#/components/schemas/IBalanceSheetSection'
            },
            type: 'array'
        },
        summary: {
            properties: {
                balanceCheck: {
                    type: 'number',
                    format: 'double'
                },
                totalEquity: {
                    type: 'number',
                    format: 'double'
                },
                totalLiabilities: {
                    type: 'number',
                    format: 'double'
                },
                totalAssets: {
                    type: 'number',
                    format: 'double'
                }
            },
            required: ['balanceCheck', 'totalEquity', 'totalLiabilities', 'totalAssets'],
            type: 'object'
        },
        reportInfo: {
            properties: {
                baseCurrency: {
                    type: 'string'
                },
                generatedAt: {
                    type: 'string'
                },
                endDate: {
                    type: 'string'
                },
                startDate: {
                    type: 'string'
                }
            },
            required: ['baseCurrency', 'generatedAt', 'endDate', 'startDate'],
            type: 'object'
        }
    },
    required: ['assets', 'liabilities', 'equity', 'summary', 'reportInfo'],
    type: 'object',
    additionalProperties: false
} as const;

export const $BalanceSheetV2DownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IReparationReportV2Item = {
    properties: {
        reparationCaseId: {
            type: 'number',
            format: 'double'
        },
        customerName: {
            type: 'string'
        },
        handlerName: {
            type: 'string'
        },
        startTime: {
            type: 'string',
            nullable: true
        },
        endTime: {
            type: 'string',
            nullable: true
        },
        repairDurationHours: {
            type: 'number',
            format: 'double',
            nullable: true
        },
        totalPrice: {
            type: 'number',
            format: 'double'
        },
        status: {
            type: 'string'
        }
    },
    required: ['reparationCaseId', 'customerName', 'handlerName', 'startTime', 'endTime', 'repairDurationHours', 'totalPrice', 'status'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IReparationReportV2KPI = {
    properties: {
        totalRepairs: {
            type: 'number',
            format: 'double'
        },
        totalAmount: {
            type: 'number',
            format: 'double'
        },
        averageRepairTimeHours: {
            type: 'number',
            format: 'double',
            nullable: true
        },
        averageRepairCost: {
            type: 'number',
            format: 'double',
            nullable: true
        },
        averageHandlingTimeByUser: {
            items: {
                properties: {
                    repairsHandled: {
                        type: 'number',
                        format: 'double'
                    },
                    averageRepairTimeHours: {
                        type: 'number',
                        format: 'double',
                        nullable: true
                    },
                    handlerName: {
                        type: 'string'
                    }
                },
                required: ['repairsHandled', 'averageRepairTimeHours', 'handlerName'],
                type: 'object'
            },
            type: 'array'
        }
    },
    required: ['totalRepairs', 'totalAmount', 'averageRepairTimeHours', 'averageRepairCost', 'averageHandlingTimeByUser'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IReparationReportV2Response = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IReparationReportV2Item'
            },
            type: 'array'
        },
        kpis: {
            '$ref': '#/components/schemas/IReparationReportV2KPI'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        limit: {
            type: 'number',
            format: 'double'
        },
        offset: {
            type: 'number',
            format: 'double'
        },
        filters: {
            properties: {
                endDate: {
                    type: 'string'
                },
                startDate: {
                    type: 'string'
                },
                search: {
                    type: 'string'
                }
            },
            type: 'object'
        }
    },
    required: ['items', 'kpis', 'total', 'limit', 'offset', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ReparationReportV2DownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ISalesReportV2KPI = {
    properties: {
        totalInvoicedSales: {
            type: 'number',
            format: 'double'
        },
        cashReceived: {
            type: 'number',
            format: 'double'
        },
        productSalesTotal: {
            type: 'number',
            format: 'double'
        },
        reparationSalesTotal: {
            type: 'number',
            format: 'double'
        },
        accountsReceivable: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalInvoicedSales', 'cashReceived', 'productSalesTotal', 'reparationSalesTotal', 'accountsReceivable'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ITotalSalesItem = {
    properties: {
        id: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {
                    type: 'string'
                }
            ]
        },
        date: {
            type: 'string'
        },
        totalInvoices: {
            type: 'number',
            format: 'double'
        },
        totalSales: {
            type: 'number',
            format: 'double'
        },
        revenue: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['id', 'date', 'totalInvoices', 'totalSales', 'revenue'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ITotalSalesTotals = {
    properties: {
        totalInvoices: {
            type: 'number',
            format: 'double'
        },
        totalSales: {
            type: 'number',
            format: 'double'
        },
        revenue: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalInvoices', 'totalSales', 'revenue'],
    type: 'object',
    additionalProperties: false
} as const;

export const $PaginatedList_ITotalSalesItem_ITotalSalesTotals_ = {
    properties: {
        totals: {
            '$ref': '#/components/schemas/ITotalSalesTotals'
        },
        pageSize: {
            type: 'number',
            format: 'double'
        },
        page: {
            type: 'number',
            format: 'double'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        items: {
            items: {
                '$ref': '#/components/schemas/ITotalSalesItem'
            },
            type: 'array'
        }
    },
    required: ['pageSize', 'page', 'total', 'items'],
    type: 'object'
} as const;

export const $IProductSalesItem = {
    properties: {
        id: {
            type: 'string'
        },
        employee: {
            type: 'string'
        },
        client: {
            type: 'string'
        },
        status: {
            type: 'string',
            enum: ['Paid', 'Partially Paid', 'Not Paid']
        },
        totalSale: {
            type: 'number',
            format: 'double'
        },
        totalPaid: {
            type: 'number',
            format: 'double'
        },
        remaining: {
            type: 'number',
            format: 'double'
        },
        revenue: {
            type: 'number',
            format: 'double'
        },
        date: {
            type: 'string'
        }
    },
    required: ['id', 'employee', 'client', 'status', 'totalSale', 'totalPaid', 'remaining', 'revenue', 'date'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IProductSalesTotals = {
    properties: {
        totalSale: {
            type: 'number',
            format: 'double'
        },
        totalPaid: {
            type: 'number',
            format: 'double'
        },
        remaining: {
            type: 'number',
            format: 'double'
        },
        revenue: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalSale', 'totalPaid', 'remaining', 'revenue'],
    type: 'object',
    additionalProperties: false
} as const;

export const $PaginatedList_IProductSalesItem_IProductSalesTotals_ = {
    properties: {
        totals: {
            '$ref': '#/components/schemas/IProductSalesTotals'
        },
        pageSize: {
            type: 'number',
            format: 'double'
        },
        page: {
            type: 'number',
            format: 'double'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        items: {
            items: {
                '$ref': '#/components/schemas/IProductSalesItem'
            },
            type: 'array'
        }
    },
    required: ['pageSize', 'page', 'total', 'items'],
    type: 'object'
} as const;

export const $IReparationSalesItem = {
    properties: {
        id: {
            type: 'string'
        },
        employee: {
            type: 'string'
        },
        client: {
            type: 'string'
        },
        status: {
            type: 'string',
            enum: ['Paid', 'Partially Paid', 'Not Paid']
        },
        totalSale: {
            type: 'number',
            format: 'double'
        },
        totalPaid: {
            type: 'number',
            format: 'double'
        },
        remaining: {
            type: 'number',
            format: 'double'
        },
        revenue: {
            type: 'number',
            format: 'double'
        },
        date: {
            type: 'string'
        }
    },
    required: ['id', 'employee', 'client', 'status', 'totalSale', 'totalPaid', 'remaining', 'revenue', 'date'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IReparationSalesTotals = {
    properties: {
        totalSale: {
            type: 'number',
            format: 'double'
        },
        totalPaid: {
            type: 'number',
            format: 'double'
        },
        remaining: {
            type: 'number',
            format: 'double'
        },
        revenue: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalSale', 'totalPaid', 'remaining', 'revenue'],
    type: 'object',
    additionalProperties: false
} as const;

export const $PaginatedList_IReparationSalesItem_IReparationSalesTotals_ = {
    properties: {
        totals: {
            '$ref': '#/components/schemas/IReparationSalesTotals'
        },
        pageSize: {
            type: 'number',
            format: 'double'
        },
        page: {
            type: 'number',
            format: 'double'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        items: {
            items: {
                '$ref': '#/components/schemas/IReparationSalesItem'
            },
            type: 'array'
        }
    },
    required: ['pageSize', 'page', 'total', 'items'],
    type: 'object'
} as const;

export const $ITopSellingProductItem = {
    properties: {
        id: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {
                    type: 'string'
                }
            ]
        },
        name: {
            type: 'string'
        },
        quantity: {
            type: 'number',
            format: 'double'
        },
        revenue: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['id', 'name', 'quantity', 'revenue'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ITopSellingProductTotals = {
    properties: {
        quantity: {
            type: 'number',
            format: 'double'
        },
        revenue: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['quantity', 'revenue'],
    type: 'object',
    additionalProperties: false
} as const;

export const $PaginatedList_ITopSellingProductItem_ITopSellingProductTotals_ = {
    properties: {
        totals: {
            '$ref': '#/components/schemas/ITopSellingProductTotals'
        },
        pageSize: {
            type: 'number',
            format: 'double'
        },
        page: {
            type: 'number',
            format: 'double'
        },
        total: {
            type: 'number',
            format: 'double'
        },
        items: {
            items: {
                '$ref': '#/components/schemas/ITopSellingProductItem'
            },
            type: 'array'
        }
    },
    required: ['pageSize', 'page', 'total', 'items'],
    type: 'object'
} as const;

export const $ISalesReportV2Response = {
    properties: {
        kpis: {
            '$ref': '#/components/schemas/ISalesReportV2KPI'
        },
        totalSales: {
            '$ref': '#/components/schemas/PaginatedList_ITotalSalesItem.ITotalSalesTotals_'
        },
        productSales: {
            '$ref': '#/components/schemas/PaginatedList_IProductSalesItem.IProductSalesTotals_'
        },
        reparationSales: {
            '$ref': '#/components/schemas/PaginatedList_IReparationSalesItem.IReparationSalesTotals_'
        },
        topSellingProducts: {
            '$ref': '#/components/schemas/PaginatedList_ITopSellingProductItem.ITopSellingProductTotals_'
        }
    },
    required: ['kpis', 'totalSales', 'productSales', 'reparationSales', 'topSellingProducts'],
    type: 'object',
    additionalProperties: false
} as const;

export const $SalesReportV2DownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IProfitReportV2KPI = {
    properties: {
        totalIncome: {
            type: 'number',
            format: 'double'
        },
        totalCogs: {
            type: 'number',
            format: 'double'
        },
        grossProfit: {
            type: 'number',
            format: 'double'
        },
        operatingProfit: {
            type: 'number',
            format: 'double'
        },
        netProfit: {
            type: 'number',
            format: 'double'
        },
        productSales: {
            type: 'number',
            format: 'double'
        },
        reparationSales: {
            type: 'number',
            format: 'double'
        },
        productCost: {
            type: 'number',
            format: 'double'
        },
        repairParts: {
            type: 'number',
            format: 'double'
        },
        profitMarginPercentage: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['totalIncome', 'totalCogs', 'grossProfit', 'operatingProfit', 'netProfit', 'productSales', 'reparationSales', 'productCost', 'repairParts', 'profitMarginPercentage'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IOperatingExpenseItem = {
    properties: {
        categoryName: {
            type: 'string'
        },
        amount: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['categoryName', 'amount'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IProfitReportV2Response = {
    properties: {
        kpis: {
            '$ref': '#/components/schemas/IProfitReportV2KPI'
        },
        operatingExpenses: {
            items: {
                '$ref': '#/components/schemas/IOperatingExpenseItem'
            },
            type: 'array'
        }
    },
    required: ['kpis', 'operatingExpenses'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ProfitReportV2DownloadResponse = {
    properties: {
        success: {
            type: 'boolean'
        },
        downloadUrl: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetChecklistItemsResponseItem = {
    properties: {
        idReparationCaseChecklistItem: {
            type: 'number',
            format: 'double'
        },
        itemTitle: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        }
    },
    required: ['idReparationCaseChecklistItem', 'itemTitle', 'isActive'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetChecklistItemsResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IGetChecklistItemsResponseItem'
            },
            type: 'array'
        },
        success: {
            type: 'boolean'
        },
        message: {
            type: 'string'
        }
    },
    required: ['items', 'success', 'message'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ReparationCaseStatus = {
    enum: ['PENDING', 'CHECKING', 'REVISED', 'CONTACTING_CUSTOMER', 'CUSTOMER_CONFIRMED', 'REPAIRING', 'COMPLETED', 'PAID', 'CANCELLED', 'PRICED', 'RECEIVED'],
    type: 'string'
} as const;

export const $IReparationCaseListItem = {
    properties: {
        idReparationCase: {
            type: 'number',
            format: 'double'
        },
        reparationCaseStatus: {
            '$ref': '#/components/schemas/ReparationCaseStatus'
        },
        reportedCaseIssue: {
            type: 'string'
        },
        firstName: {
            type: 'string'
        },
        lastName: {
            type: 'string'
        },
        primaryPhone: {
            type: 'string'
        },
        secondaryPhone: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        address: {
            type: 'string'
        },
        model: {
            type: 'string'
        },
        imeiNumber: {
            type: 'string'
        },
        deviceLockCode: {
            type: 'string'
        },
        devicePattern: {
            type: 'string'
        },
        frontViewMediaUrl: {
            type: 'string'
        },
        backViewMediaUrl: {
            type: 'string'
        },
        leftSideMediaUrl: {
            type: 'string'
        },
        rightSideMediaUrl: {
            type: 'string'
        },
        devicePowerStatus: {
            type: 'string'
        },
        deviceOffReason: {
            type: 'string'
        },
        testFee: {
            type: 'number',
            format: 'double'
        },
        testIsRequiredBeforeRepair: {
            type: 'boolean'
        },
        additionalNotes: {
            type: 'string'
        },
        createdAt: {
            type: 'string',
            format: 'date-time'
        },
        updatedAt: {
            type: 'string',
            format: 'date-time'
        },
        brand: {
            '$ref': '#/components/schemas/IBrandItem'
        },
        totalPrice: {
            type: 'number',
            format: 'double'
        },
        paymentMethod: {
            allOf: [
                {
                    '$ref': '#/components/schemas/IPaymentMethodItem'
                }
            ],
            nullable: true
        }
    },
    required: ['idReparationCase', 'reparationCaseStatus', 'reportedCaseIssue', 'firstName', 'lastName', 'primaryPhone', 'secondaryPhone', 'email', 'address', 'model', 'imeiNumber', 'deviceLockCode', 'devicePattern', 'frontViewMediaUrl', 'backViewMediaUrl', 'leftSideMediaUrl', 'rightSideMediaUrl', 'devicePowerStatus', 'deviceOffReason', 'testFee', 'testIsRequiredBeforeRepair', 'additionalNotes', 'createdAt', 'updatedAt', 'brand', 'totalPrice', 'paymentMethod'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IStatusKpi = {
    properties: {
        statusName: {
            type: 'string'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['statusName', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IPaymentMethodTotalForReparation = {
    properties: {
        name: {
            type: 'string'
        },
        amount: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['name', 'amount'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IReparationCasesListResponse = {
    properties: {
        total: {
            type: 'number',
            format: 'double'
        },
        items: {
            items: {
                '$ref': '#/components/schemas/IReparationCaseListItem'
            },
            type: 'array'
        },
        totalNewCasesToday: {
            type: 'number',
            format: 'double'
        },
        totalPendingCasesToday: {
            type: 'number',
            format: 'double'
        },
        totalCompletedCasesToday: {
            type: 'number',
            format: 'double'
        },
        statusKpis: {
            items: {
                '$ref': '#/components/schemas/IStatusKpi'
            },
            type: 'array'
        },
        paymentMethods: {
            items: {
                '$ref': '#/components/schemas/IPaymentMethodTotalForReparation'
            },
            type: 'array'
        },
        totalPaid: {
            type: 'number',
            format: 'double'
        },
        totalAmount: {
            type: 'number',
            format: 'double'
        },
        totalUnpaid: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['total', 'items', 'totalNewCasesToday', 'totalPendingCasesToday', 'totalCompletedCasesToday', 'statusKpis', 'paymentMethods', 'totalPaid', 'totalAmount', 'totalUnpaid'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IReparationCaseHistoryItem = {
    properties: {
        idReparationHistory: {
            type: 'number',
            format: 'double'
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        action: {
            type: 'string'
        },
        entryDate: {
            type: 'string',
            format: 'date-time'
        },
        user: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['idReparationHistory', 'title', 'entryDate'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IReparationCaseChecklistItem = {
    properties: {
        idReparationCaseChecklistItem: {
            type: 'number',
            format: 'double'
        },
        itemTitle: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        }
    },
    required: ['idReparationCaseChecklistItem', 'itemTitle', 'isActive'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IReparationCase = {
    properties: {
        idReparationCase: {
            type: 'number',
            format: 'double'
        },
        reparationCaseStatus: {
            '$ref': '#/components/schemas/ReparationCaseStatus'
        },
        reportedCaseIssue: {
            type: 'string'
        },
        firstName: {
            type: 'string'
        },
        lastName: {
            type: 'string'
        },
        primaryPhone: {
            type: 'string'
        },
        secondaryPhone: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        address: {
            type: 'string'
        },
        brand: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {
                    '$ref': '#/components/schemas/IBrandItem'
                }
            ]
        },
        model: {
            type: 'string'
        },
        imeiNumber: {
            type: 'string'
        },
        deviceLockCode: {
            type: 'string'
        },
        devicePattern: {
            type: 'string'
        },
        frontViewMediaUrl: {
            type: 'string'
        },
        backViewMediaUrl: {
            type: 'string'
        },
        leftSideMediaUrl: {
            type: 'string'
        },
        rightSideMediaUrl: {
            type: 'string'
        },
        devicePowerStatus: {
            type: 'string',
            enum: ['ON', 'OFF']
        },
        deviceOffReason: {
            type: 'string'
        },
        testFee: {
            type: 'number',
            format: 'double'
        },
        testIsRequiredBeforeRepair: {
            type: 'boolean'
        },
        additionalNotes: {
            type: 'string'
        },
        reparationCaseHistoryItems: {
            items: {
                '$ref': '#/components/schemas/IReparationCaseHistory'
            },
            type: 'array'
        },
        reparationCaseChecklistValues: {
            items: {
                '$ref': '#/components/schemas/IReparationCaseChecklistValue'
            },
            type: 'array'
        },
        reparationCaseReview: {
            '$ref': '#/components/schemas/IReparationCaseReview'
        },
        cancellationReason: {
            type: 'string'
        },
        deviceAccountType: {
            type: 'string'
        },
        deviceAccountEmail: {
            type: 'string'
        },
        deviceAccountPassword: {
            type: 'string'
        },
        startTime: {
            type: 'string',
            format: 'date-time'
        },
        endTime: {
            type: 'string',
            format: 'date-time'
        }
    },
    required: ['idReparationCase', 'reparationCaseStatus', 'reportedCaseIssue', 'firstName', 'lastName', 'primaryPhone', 'address', 'brand', 'model', 'imeiNumber'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IReparationCaseHistory = {
    properties: {
        idReparationHistory: {
            type: 'number',
            format: 'double'
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        action: {
            type: 'string'
        },
        entryDate: {
            type: 'string',
            format: 'date-time'
        },
        user: {
            '$ref': '#/components/schemas/IGetUserResponse'
        },
        reparationCase: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/IReparationCase'
                },
                {
                    type: 'number',
                    format: 'double'
                }
            ]
        }
    },
    required: ['idReparationHistory', 'title', 'entryDate'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IReparationCaseChecklistValue = {
    properties: {
        idReparationCaseChecklistValue: {
            type: 'number',
            format: 'double'
        },
        refIdReparationCaseChecklistItem: {
            type: 'number',
            format: 'double'
        },
        reparationCaseChecklistItem: {
            '$ref': '#/components/schemas/IReparationCaseChecklistItem'
        },
        reparationCase: {
            '$ref': '#/components/schemas/IReparationCase'
        },
        hasIssue: {
            type: 'boolean'
        },
        details: {
            type: 'string'
        }
    },
    required: ['idReparationCaseChecklistValue', 'refIdReparationCaseChecklistItem', 'reparationCaseChecklistItem', 'reparationCase', 'hasIssue'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IReparationCaseReview = {
    properties: {
        idReparationCaseReview: {
            type: 'number',
            format: 'double'
        },
        description: {
            type: 'string'
        },
        pricing: {
            type: 'number',
            format: 'double'
        },
        createdDate: {
            type: 'string',
            format: 'date-time'
        },
        createdBy: {
            '$ref': '#/components/schemas/IUser'
        }
    },
    required: ['idReparationCaseReview', 'description'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IReparationCaseDetails = {
    properties: {
        idReparationCase: {
            type: 'number',
            format: 'double'
        },
        reparationCaseStatus: {
            '$ref': '#/components/schemas/ReparationCaseStatus'
        },
        reportedCaseIssue: {
            type: 'string'
        },
        firstName: {
            type: 'string'
        },
        lastName: {
            type: 'string'
        },
        primaryPhone: {
            type: 'string'
        },
        secondaryPhone: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        address: {
            type: 'string'
        },
        brand: {
            '$ref': '#/components/schemas/IBrandItem'
        },
        model: {
            type: 'string'
        },
        imeiNumber: {
            type: 'string'
        },
        deviceLockCode: {
            type: 'string'
        },
        devicePattern: {
            type: 'string'
        },
        frontViewMediaUrl: {
            type: 'string'
        },
        backViewMediaUrl: {
            type: 'string'
        },
        leftSideMediaUrl: {
            type: 'string'
        },
        rightSideMediaUrl: {
            type: 'string'
        },
        frontViewDownloadUrl: {
            type: 'string'
        },
        backViewDownloadUrl: {
            type: 'string'
        },
        leftSideDownloadUrl: {
            type: 'string'
        },
        rightSideDownloadUrl: {
            type: 'string'
        },
        devicePowerStatus: {
            type: 'string'
        },
        deviceOffReason: {
            type: 'string'
        },
        testFee: {
            type: 'number',
            format: 'double'
        },
        testIsRequiredBeforeRepair: {
            type: 'boolean'
        },
        additionalNotes: {
            type: 'string'
        },
        reparationCaseHistoryItems: {
            items: {
                '$ref': '#/components/schemas/IReparationCaseHistoryItem'
            },
            type: 'array'
        },
        reparationCaseChecklistValues: {
            items: {
                '$ref': '#/components/schemas/IReparationCaseChecklistValue'
            },
            type: 'array'
        },
        cancellationReason: {
            type: 'string'
        },
        invoice: {
            '$ref': '#/components/schemas/IGetInvoiceDetailsResponse'
        },
        remainingBalance: {
            type: 'number',
            format: 'double'
        },
        paidAmount: {
            type: 'number',
            format: 'double'
        },
        deviceAccountType: {
            type: 'string'
        },
        deviceAccountEmail: {
            type: 'string'
        },
        deviceAccountPassword: {
            type: 'string'
        },
        startTime: {
            type: 'string',
            format: 'date-time'
        },
        endTime: {
            type: 'string',
            format: 'date-time'
        },
        paymentMethod: {
            '$ref': '#/components/schemas/IPaymentMethodItem'
        },
        reparationCaseNumber: {
            type: 'string'
        },
        location: {
            properties: {
                locationName: {
                    type: 'string'
                },
                idLocation: {
                    type: 'number',
                    format: 'double'
                }
            },
            required: ['locationName', 'idLocation'],
            type: 'object'
        }
    },
    required: ['idReparationCase', 'reparationCaseStatus', 'reportedCaseIssue', 'firstName', 'lastName', 'primaryPhone', 'address', 'brand', 'model', 'imeiNumber', 'reparationCaseHistoryItems', 'reparationCaseChecklistValues'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetReparationCaseDetailsResponse = {
    properties: {
        data: {
            '$ref': '#/components/schemas/IReparationCaseDetails'
        },
        message: {
            type: 'string'
        },
        success: {
            type: 'boolean'
        }
    },
    required: ['data', 'message', 'success'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreateOrUpdateReparationCaseReview = {
    properties: {
        description: {
            type: 'string'
        },
        pricing: {
            type: 'number',
            format: 'double'
        },
        paymentMethod: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['description'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreateReparationCaseItemInput = {
    properties: {
        description: {
            type: 'string'
        },
        quantity: {
            type: 'number',
            format: 'double'
        },
        unitPrice: {
            type: 'number',
            format: 'double'
        },
        totalPrice: {
            type: 'number',
            format: 'double'
        },
        itemType: {
            type: 'string',
            enum: ['PRODUCT', 'SERVICE']
        },
        product: {
            type: 'number',
            format: 'double'
        },
        service: {
            type: 'number',
            format: 'double'
        },
        reparationCaseItemLocation: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['quantity', 'unitPrice', 'totalPrice', 'itemType'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdateReparationCaseItemInput = {
    properties: {
        description: {
            type: 'string'
        },
        quantity: {
            type: 'number',
            format: 'double'
        },
        unitPrice: {
            type: 'number',
            format: 'double'
        },
        totalPrice: {
            type: 'number',
            format: 'double'
        },
        itemType: {
            type: 'string',
            enum: ['PRODUCT', 'SERVICE']
        },
        product: {
            type: 'number',
            format: 'double'
        },
        service: {
            type: 'number',
            format: 'double'
        },
        reparationCaseItemLocation: {
            type: 'number',
            format: 'double'
        },
        deviceAccountType: {
            type: 'string'
        },
        deviceAccountEmail: {
            type: 'string'
        },
        deviceAccountPassword: {
            type: 'string'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $ICustomer = {
    properties: {
        idCustomer: {
            type: 'number',
            format: 'double'
        },
        customerName: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        country: {
            type: 'string'
        },
        city: {
            type: 'string'
        },
        address: {
            type: 'string'
        },
        phone: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        website: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        createdBy: {
            type: 'string'
        },
        createdDate: {
            type: 'string',
            format: 'date-time'
        },
        updatedBy: {
            type: 'string'
        },
        updatedDate: {
            type: 'string',
            format: 'date-time'
        }
    },
    required: ['idCustomer', 'customerName'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICustomerListResponse = {
    properties: {
        total: {
            type: 'number',
            format: 'double'
        },
        items: {
            items: {
                '$ref': '#/components/schemas/ICustomer'
            },
            type: 'array'
        }
    },
    required: ['total', 'items'],
    type: 'object',
    additionalProperties: false
} as const;

export const $CreateCustomerInput = {
    properties: {
        customerName: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        country: {
            type: 'string'
        },
        address: {
            type: 'string'
        },
        phone: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        website: {
            type: 'string'
        },
        wechatID: {
            type: 'string'
        },
        altPhone: {
            type: 'string'
        },
        whatsappPhone: {
            type: 'string'
        }
    },
    required: ['customerName'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdateCustomerInput = {
    properties: {
        customerName: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        country: {
            type: 'string'
        },
        address: {
            type: 'string'
        },
        phone: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        website: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        wechatID: {
            type: 'string'
        },
        altPhone: {
            type: 'string'
        },
        whatsappPhone: {
            type: 'string'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $AccountListResponse = {
    properties: {
        total: {
            type: 'number',
            format: 'double'
        },
        items: {
            items: {
                '$ref': '#/components/schemas/IAccountItem'
            },
            type: 'array'
        }
    },
    required: ['total', 'items'],
    type: 'object',
    additionalProperties: false
} as const;

export const $DefaultQueryInput = {
    properties: {
        sort: {},
        pagination: {},
        filters: {}
    },
    required: ['sort', 'pagination', 'filters'],
    type: 'object',
    additionalProperties: false
} as const;

export const $AccountDetails = {
    properties: {
        idAccount: {
            type: 'number',
            format: 'double'
        },
        accountName: {
            type: 'string'
        },
        accountNumber: {
            type: 'string'
        },
        accountBalance: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['idAccount', 'accountName', 'accountBalance'],
    type: 'object',
    additionalProperties: false
} as const;

export const $AccountGroupDetails = {
    properties: {
        totalBalance: {
            type: 'number',
            format: 'double'
        },
        accounts: {
            items: {
                '$ref': '#/components/schemas/AccountDetails'
            },
            type: 'array'
        }
    },
    required: ['totalBalance', 'accounts'],
    type: 'object',
    additionalProperties: false
} as const;

export const $AccountTypeGroup = {
    properties: {
        totalBalance: {
            type: 'number',
            format: 'double'
        },
        groups: {
            properties: {},
            additionalProperties: {
                '$ref': '#/components/schemas/AccountGroupDetails'
            },
            type: 'object'
        }
    },
    required: ['totalBalance', 'groups'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ChartOfAccountsResponse = {
    properties: {},
    type: 'object',
    additionalProperties: {
        '$ref': '#/components/schemas/AccountTypeGroup'
    }
} as const;

export const $TransactionItem = {
    properties: {
        idTransaction: {
            type: 'number',
            format: 'double'
        },
        transactionNumber: {
            type: 'string'
        },
        transactionType: {
            type: 'string'
        },
        amount: {
            type: 'number',
            format: 'double'
        },
        transactionDate: {
            type: 'string',
            format: 'date-time'
        },
        notes: {
            type: 'string'
        },
        transactionDescription: {
            type: 'string'
        },
        company: {},
        financialYear: {},
        currency: {},
        exchangeRate: {},
        debitAccount: {},
        creditAccount: {},
        exchangeRateAmount: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['transactionNumber', 'transactionType', 'amount', 'transactionDate'],
    type: 'object',
    additionalProperties: false
} as const;

export const $TransactionListResponse = {
    properties: {
        total: {
            type: 'number',
            format: 'double'
        },
        items: {
            items: {
                '$ref': '#/components/schemas/TransactionItem'
            },
            type: 'array'
        }
    },
    required: ['total', 'items'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreateTransactionInput = {
    properties: {
        transactionType: {
            type: 'string'
        },
        transactionDescription: {
            type: 'string'
        },
        amount: {
            type: 'number',
            format: 'double'
        },
        transactionDate: {
            type: 'string',
            format: 'date-time'
        },
        notes: {
            type: 'string'
        },
        debitAccount: {
            type: 'number',
            format: 'double'
        },
        creditAccount: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['transactionType', 'transactionDescription', 'amount', 'transactionDate', 'debitAccount', 'creditAccount'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdateTransactionInput = {
    properties: {
        transactionDescription: {
            type: 'string'
        },
        amount: {
            type: 'number',
            format: 'double'
        },
        transactionDate: {
            type: 'string',
            format: 'date-time'
        },
        notes: {
            type: 'string'
        },
        debitAccount: {
            type: 'number',
            format: 'double'
        },
        creditAccount: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['transactionDescription', 'amount', 'transactionDate', 'debitAccount', 'creditAccount'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IExpenseCategoryItem = {
    properties: {
        idExpenseCategory: {
            type: 'number',
            format: 'double'
        },
        name: {
            type: 'string'
        },
        icon: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        account: {
            '$ref': '#/components/schemas/IAccountItem'
        }
    },
    required: ['idExpenseCategory', 'name', 'icon', 'description', 'isActive', 'account'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetExpenseCategoriesResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IExpenseCategoryItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IExpenseItem = {
    properties: {
        idExpense: {
            type: 'number',
            format: 'double'
        },
        expenseName: {
            type: 'string'
        },
        expenseDescription: {
            type: 'string'
        },
        expenseAmount: {
            type: 'number',
            format: 'double'
        },
        expenseDate: {
            type: 'string',
            format: 'date-time'
        },
        debitAccount: {
            type: 'number',
            format: 'double'
        },
        creditAccount: {
            type: 'number',
            format: 'double'
        },
        expenseCategory: {
            type: 'number',
            format: 'double'
        },
        createdDate: {
            type: 'string',
            format: 'date-time'
        },
        createdBy: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {}
            ]
        },
        updatedDate: {
            type: 'string',
            format: 'date-time'
        },
        updatedBy: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {}
            ]
        }
    },
    required: ['idExpense', 'expenseName', 'expenseDescription', 'expenseAmount', 'expenseDate', 'debitAccount', 'creditAccount', 'expenseCategory', 'createdDate', 'createdBy'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetExpensesResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/IExpenseItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $CreateExpenseCategoryInput = {
    properties: {
        name: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        account: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['name'],
    type: 'object',
    additionalProperties: false
} as const;

export const $CreateExpenseInput = {
    properties: {
        expenseName: {
            type: 'string'
        },
        expenseDescription: {
            type: 'string'
        },
        expenseAmount: {
            type: 'number',
            format: 'double'
        },
        expenseDate: {
            type: 'string',
            format: 'date-time'
        },
        paymentAccount: {
            type: 'number',
            format: 'double'
        },
        expenseCategory: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['expenseDescription', 'expenseAmount', 'expenseDate', 'paymentAccount', 'expenseCategory'],
    type: 'object',
    additionalProperties: false
} as const;

export const $TaxListResponse = {
    properties: {
        items: {
            items: {
                '$ref': '#/components/schemas/ITaxItem'
            },
            type: 'array'
        },
        total: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['items', 'total'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreateTaxInput = {
    properties: {
        taxName: {
            type: 'string'
        },
        taxRate: {
            type: 'number',
            format: 'double'
        },
        taxType: {
            '$ref': '#/components/schemas/TaxType'
        },
        taxDescription: {
            type: 'string'
        }
    },
    required: ['taxName', 'taxRate', 'taxType'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdateTaxInput = {
    properties: {
        idTax: {
            type: 'number',
            format: 'double'
        },
        taxName: {
            type: 'string'
        },
        taxRate: {
            type: 'number',
            format: 'double'
        },
        taxType: {
            type: 'string'
        },
        taxDescription: {
            type: 'string'
        }
    },
    required: ['idTax', 'taxName', 'taxRate', 'taxType', 'taxDescription'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetCurrencyListResponse = {
    properties: {
        total: {
            type: 'number',
            format: 'double'
        },
        items: {
            items: {
                '$ref': '#/components/schemas/ICurrency'
            },
            type: 'array'
        }
    },
    required: ['total', 'items'],
    type: 'object',
    additionalProperties: false
} as const;

export const $ICreateCurrencyInput = {
    properties: {
        currencyName: {
            type: 'string'
        },
        currencyCode: {
            type: 'string'
        },
        currencySymbol: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        isDefault: {
            type: 'boolean'
        },
        rate: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['currencyName', 'currencyCode', 'currencySymbol', 'rate'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IBankAccountItem = {
    properties: {
        idBankAccount: {
            type: 'number',
            format: 'double'
        },
        bankAccountName: {
            type: 'string'
        },
        bankName: {
            type: 'string'
        },
        bankAccountNumber: {
            type: 'string'
        },
        bankAccountType: {
            type: 'string'
        },
        bankAccountHolderName: {
            type: 'string'
        },
        bankAccountHolderType: {
            type: 'string'
        },
        company: {
            type: 'number',
            format: 'double'
        },
        account: {
            type: 'number',
            format: 'double'
        },
        currency: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/ICurrency'
                },
                {
                    type: 'number',
                    format: 'double'
                }
            ]
        },
        createdDate: {
            type: 'string',
            format: 'date-time'
        },
        createdBy: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {}
            ]
        },
        updatedDate: {
            type: 'string',
            format: 'date-time'
        },
        updatedBy: {
            anyOf: [
                {
                    type: 'number',
                    format: 'double'
                },
                {}
            ]
        }
    },
    required: ['idBankAccount', 'bankAccountName', 'company', 'account', 'currency', 'createdDate', 'createdBy'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IGetBankAccountsResponse = {
    properties: {
        total: {
            type: 'number',
            format: 'double'
        },
        items: {
            items: {
                '$ref': '#/components/schemas/IBankAccountItem'
            },
            type: 'array'
        }
    },
    required: ['total', 'items'],
    type: 'object',
    additionalProperties: false
} as const;

export const $BankAccountType = {
    enum: ['CURRENT', 'CHECKING', 'SAVINGS', 'LOAN', 'OTHER'],
    type: 'string'
} as const;

export const $BankAccountHolderType = {
    enum: ['INDIVIDUAL', 'COMPANY', 'OTHER'],
    type: 'string'
} as const;

export const $ICreateBankAccountInput = {
    properties: {
        bankAccountName: {
            type: 'string'
        },
        bankName: {
            type: 'string'
        },
        bankAccountNumber: {
            type: 'string'
        },
        bankAccountType: {
            '$ref': '#/components/schemas/BankAccountType'
        },
        bankAccountHolderName: {
            type: 'string'
        },
        bankAccountHolderType: {
            '$ref': '#/components/schemas/BankAccountHolderType'
        },
        currency: {
            type: 'number',
            format: 'double'
        },
        openingBalance: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['bankAccountName'],
    type: 'object',
    additionalProperties: false
} as const;

export const $IUpdateBankAccountInput = {
    properties: {
        bankAccountName: {
            type: 'string'
        },
        bankName: {
            type: 'string'
        },
        bankAccountNumber: {
            type: 'string'
        },
        bankAccountType: {
            '$ref': '#/components/schemas/BankAccountType'
        },
        bankAccountHolderName: {
            type: 'string'
        },
        bankAccountHolderType: {
            '$ref': '#/components/schemas/BankAccountHolderType'
        },
        currency: {
            type: 'number',
            format: 'double'
        },
        openingBalance: {
            type: 'number',
            format: 'double'
        }
    },
    type: 'object',
    additionalProperties: false
} as const;

export const $AccountSubGroup = {
    enum: ['CASH', 'BANK_ACCOUNTS', 'PETTY_CASH', 'MARKETABLE_SECURITIES', 'TRADE_RECEIVABLES', 'ALLOWANCE_FOR_DOUBTFUL_ACCOUNTS', 'RAW_MATERIALS', 'WORK_IN_PROGRESS', 'FINISHED_GOODS', 'LAND', 'BUILDINGS', 'EQUIPMENT', 'VEHICLES', 'ACCUMULATED_DEPRECIATION', 'PATENTS', 'TRADEMARKS', 'GOODWILL', 'LONG_TERM_INVESTMENTS', 'TRADE_PAYABLES', 'NOTES_PAYABLE', 'CREDIT_CARD_PAYABLES', 'CURRENT_PORTION_LONG_TERM_DEBT', 'WAGES_PAYABLE', 'TAXES_PAYABLE', 'INTEREST_PAYABLE', 'UNEARNED_REVENUE', 'BONDS_PAYABLE', 'LEASE_OBLIGATIONS', 'DEFERRED_TAX_LIABILITIES', 'COMMON_STOCK_ISSUED', 'PREFERRED_STOCK_ISSUED', 'CAPITAL_SURPLUS', 'TREASURY_STOCK', 'RETAINED_EARNINGS_UNAPPROPRIATED', 'RETAINED_EARNINGS_APPROPRIATED', 'PRODUCT_SALES', 'SERVICE_SALES', 'CONSULTING_REVENUE', 'RENTAL_INCOME', 'INTEREST_INCOME', 'DIVIDEND_INCOME', 'GAIN_ON_SALE_OF_ASSETS', 'DIRECT_MATERIALS', 'DIRECT_LABOR', 'MANUFACTURING_OVERHEAD', 'SALARIES_EXPENSE', 'RENT_EXPENSE', 'UTILITIES_EXPENSE', 'ADVERTISING_EXPENSE', 'OFFICE_SUPPLIES_EXPENSE', 'DEPRECIATION_EXPENSE', 'AMORTIZATION_EXPENSE', 'INTEREST_EXPENSE', 'INCOME_TAX_EXPENSE', 'LOSS_ON_SALE_OF_ASSETS', 'ROUNDING_DIFFERENCE_EXPENSE', 'ROUNDING_DIFFERENCE_INCOME', 'REALIZED_CURRENCY_GAIN', 'REALIZED_CURRENCY_LOSS', 'UNREALIZED_CURRENCY_GAIN', 'UNREALIZED_CURRENCY_LOSS', 'INVENTORY', 'ACCUMULATED_DEPRECIATION_EQUIPMENT', 'ACCRUED_EXPENSES', 'SALES_TAX_PAYABLE', 'INCOME_TAX_PAYABLE', 'PAYROLL_TAX_PAYABLE', 'BANK_LOANS', 'OWNERS_CAPITAL', 'RETAINED_EARNINGS_ACCOUNT', 'ONLINE_SALES', 'RETAIL_SALES', 'WHOLESALE_SALES', 'GENERAL_ADMINISTRATIVE', 'BANK_FEES', 'INSURANCE_EXPENSE', 'OFFICE_SUPPLIES', 'REPAIRS_MAINTENANCE', 'SHIPPING_EXPENSE', 'TELEPHONE_EXPENSE', 'TRAVEL_EXPENSE', 'WAGES_EXPENSE', 'PAYROLL_TAX_EXPENSE', 'EMPLOYEE_BENEFITS_EXPENSE', 'MERCHANDISE_PURCHASES', 'RAW_MATERIAL_PURCHASES', 'FOREIGN_EXCHANGE_GAIN', 'MISCELLANEOUS_EXPENSE', 'OTHER_ASSET', 'OTHER_EXPENSE', 'OTHER_INCOME', 'OTHER_LIABILITY', 'OTHER_REVENUE', 'OTHER_EQUITY', 'PREPAID_EXPENSES', 'DISCOUNT_EXPENSE', 'DISCOUNTS_GIVEN', 'CUSTOMER_DEPOSITS', 'VARIANCE_ADJUSTMENTS', 'GST_PAYABLE', 'VAT_PAYABLE', 'INVESTOR_CAPITAL', 'INVESTOR_DISTRIBUTIONS'],
    type: 'string'
} as const;

export const $ICreateAccountInput = {
    properties: {
        accountName: {
            type: 'string'
        },
        accountSubgroup: {
            '$ref': '#/components/schemas/AccountSubGroup'
        },
        accountNumber: {
            type: 'string'
        }
    },
    required: ['accountName', 'accountSubgroup'],
    type: 'object',
    additionalProperties: false
} as const;